import React, { useEffect, useRef, useState } from "react";
import { useSubmitGuard } from "../../hooks/useSubmitGuard";
import LeftIcon from "../../images/LeftIcon";
import PrintIcon from "../../images/PrintIcon";
import ArrowRightIcon from "../../images/ArrowRightIcon";
import DraftIcon from "../../images/DraftIcon";
import SaveIcon from "../../images/SaveIcon";
import DatePicker from "react-datepicker";
import PlusGreenIcon from "../../images/PlusGreenIcon";
import DeleteIcon from "../../images/DeleteIcon";
import MinusQuantity from "../../images/MinusQuantity";
import PlusQuantity from "../../images/PlusQuantity";
import PlusActiveIcon from "../../images/PlusActiveIcon";
import CloseIcon from "../../images/CloseIcon";
import PlusIconGray from "../../images/PlusIconGray";
import {
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
  webRoute,
} from "../../services/navigate.service";
import ErrorIcon from "../../images/ErrorIcon";
import {
  createSales,
  createSalesPayment,
  getDetailSales,
  getListProduct,
  getPaymentType,
  updateSales,
  updateStatus,
} from "../../services/sales.service";
import {
  validateDecimalNumer,
  validateEmail,
  validateNoSpecialChars,
  validateNoSpecialCharsOrSpaces,
  validateOnlyNumbers,
  validateOnlyNumbersNotThree,
} from "../../validation/ValidationInput";
import { getClients } from "../../services/client.service";
import { loadTerm } from "../../services/term.service";
import TagStatus from "../../components/TagStatus";
import UpdateSaleIcon from "../../images/UpdateSaleIcon";
import RejectIcon from "../../images/RejectIcon";
import BackIcon from "../../images/BackIcon";
import {
  checkInvoiceNumber,
  createPurchases,
  createPurchasesPayment,
  getDetailPurchases,
  getTransactionMonth,
  updatePurchases,
  updateStatusPurchases,
} from "../../services/purchases.services";
import UploadIcon from "../../images/UploadIcon";
import { getTax } from "../../services/tax.services";
import PopupLocation from "../../components/PopupLocation";
import { DropdownSearch } from "../../components/DropdownSearch";
import { showToast } from "../../services/toast.service";
import { showApiError as showApiErrorToast } from "../../services/apiError";
import UploadIconV2 from "../../images/UploadIconV2";
import BalanceIcon from "../../images/BalanceIcon";
import { useResponsive } from "../../hook/useResponsive";
import { useAsyncDropdown } from "../../hook/useAsyncDropdown";
type Product = {
  id: string;
  itemName: string;
};

type Tax = {
  id: string;
  primaryRate: string;
};

interface purchaseDetailPayload {
  recordType: number;
  articleId?: string;
  itemName: string;
  sku: string;
  sequenceNo: number;
  tax?: number;
  primaryRate: number;
  quantity: number;
  price: number;
  amount?: number;
  discount?: number;
  taxId?: string;
  productPriceId: string;
  note?: string;
}
interface CategoryChildren {
  id: string;
  code: string;
  name: string;
}
interface Status {
  id: string;
  code: string;
  name: string;
}
const CreatePurchases = () => {
  const preLanguage = localStorage.getItem("language");
  const [showSave, setShowSave] = useState<boolean>(true);
  const [statusCreditNote, setStatusCreditNote] = useState<boolean>(true);
  const [language, setLanguage] = useState<any>(null);
  const [formValues, setFormValues] = useState<any>({
    clientId: "",
    companyNumber: "",
    businessAddress: "",
    phoneNumber: "",
    transactionMonthsId: "",
    termId: "",
    invoiceNumber: "",
    creditNoteAmount: 0,
    isImport: false,
    customsDuty: "",
    excise: "",
    importVat: "",
    customsReference: "",
    customsDate: null,
  });
  const [listTax, setListTax] = useState<any>([]);
  const [showPayment, setShowPayment] = useState<boolean>(false);
  const [listPayment, setListPayment] = useState<any>([]);
  const [fileName, setFileName] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [statusPayment, setStatusPayment] = useState<boolean>(false);
  const [clients, setClients] = useState<any>([]);
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);
  const [listMonths, setListMonths] = useState<any>([]);
  const [searchClient, setSearchClient] = useState("");
  const [errors, setErrors] = useState<any>({
    invoiceNumber: "",
  });
  const PAGE_SIZE = 10;
  const [paymentType, setPayemntType] = useState("");
  const [isProductPriceDropdownOpen, setIsProductPriceDropdownOpen] = useState<{
    [key: number]: boolean;
  }>({});
  const [formValuesPayment, setFormValuesPayment] = useState<any>();
  const [listProduct, setListProduct] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  const [paymentTerm, setPaymentTerm] = useState("");
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [base64Image, setBase64Image] = useState<any>("");
  const [base64PDF, setBase64PDF] = useState<any>("");
  const [fileUpload, setFileUpload] = useState<any>("");
  const [isPaymentDropdownOpen, setIsPaymentDropdownOpen] = useState(false);
  const [searchProductPrice, setSearchProductPrice] = useState<any>([]);
  const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownPaymentRef = useRef<HTMLDivElement>(null);
  const paymentRef = useRef<HTMLDivElement>(null);
  const [payment, setPayemnt] = useState<any>([]);
  const categoryRef = useRef<HTMLDivElement>(null);
  const monthRef = useRef<HTMLDivElement>(null);
  const companyId: string = localStorage.getItem("companyId") || "";
  const locationId: string = localStorage.getItem("locationId") || "";
  const dropdownProductPriceRef = useRef<HTMLDivElement>(null);
  const dropdownTaxRef = useRef<any[]>([]);
  const popupRef = useRef<HTMLDivElement>(null);
  const [stateButton, setStateButton] = useState(true);
  const [searchTaxMap, setSearchTaxMap] = useState<any>({});
  const [openDropdownIndexes, setOpenDropdownIndexes] = useState<{
    [key: number]: boolean;
  }>({});
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const calculatedWidth = windowWidth / 1290;
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showPopupImage, setShowPopupImage] = useState<boolean>(false);
  const { isMobile, getWidth } = useResponsive();
  const [showOption, setShowOption] = useState<any>({
    check: false,
    type: "",
  });
  const [hasMore, setHasMore] = useState({
    client: true,
    product: true,
  });
  const [loading, setLoading] = useState({
    client: false,
    product: false,
  });
  const hasLoadedPageRef = useRef<Set<number>>(new Set());
  const path = window.location.pathname;
  const id: string = path.split("/").pop() || "";
  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 50,
    searchValue: "",
    sort: "DESC",
    pageProduct: 1,
    pageClient: 1,
    searchProduct: "",
    searchClient: "",
  });
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  // Escape closes the payment drawer, matching the backdrop-click dismissal.
  useEffect(() => {
    if (!showPayment) return;
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") setShowPayment(false);
    };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [showPayment]);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const addRow = () => {
    setIsModalOpen(true);
  };
  const getPrimaryTax = (dataTax: any, id: any) => {
    const taxes = Array.isArray(dataTax) ? dataTax : dataTax?.data ?? [];
    if (!id || taxes.length === 0) return "";
    return taxes.find((val: any) => val.taxGroupId === id)?.primaryRate ?? "";
  };

  const getTerms = async (termId: string | null) => {
    try {
      const response = await loadTerm(filter);
      const value: any = response.data;
      setPayemnt(value.data);
      const count: any = value.data.filter(
        (term: any) => term.isDefault === true,
      );
      if (count.length === 1) {
        setFormValues((prev: any) => ({ ...prev, termId: count[0]?.id }));
        setPaymentTerm(count[0]?.termName);
      }
      if (id !== "new") {
        const term: any = value.data.find((value: any) => value.id === termId);
        setFormValues((prev: any) => ({ ...prev, termId: term?.id }));
        setPaymentTerm(term?.termName);
      }
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };

  const handleMonthSelect = (month: any) => {
    setSelectedMonth(
      String(month.transactionYear + " - " + month.monthSequence),
    );
    const fromDate = new Date(month.fromDate);
    setFormValues((prev: any) => ({
      ...prev,
      transactionMonthsId: month.id,
      receivedOn: fromDate.toISOString(),
    }));
    setIsMonthDropdownOpen(false);
  };
  const convertToSaleDetailsPayload = (data: any[]): any[] => {
    return data.map((item) => {
      const payload: any = {
        recordType: item.recordType,
        articleId: item.articleId,
        itemName: item.itemName,
        sku: item.sku,
        primaryRate: parseFloat(item.price),
        tax: parseFloat(
          (item.amount - item.amount / (1 + item.tax / 100)).toFixed(2),
        ),
        net: parseFloat((item.amount / (1 + item.tax / 100)).toFixed(2)),
        quantity: item.quantity ? item.quantity : 1,
        price: parseFloat(item.price),
        amount: item.amount ? parseFloat(item.amount) : undefined,
        discount: item.discount ? parseFloat(item.discount) : undefined,
        taxId: item.taxId,
        productPriceId: item.productPriceId,
        note: item.note,
      };
      if (item.recordType === 1) {
        const result: any = {
          ...payload,
          type: item.type,
        };
        if (item.assetCategoryId) {
          result.assetCategoryId = item.assetCategoryId;
        }
        if (item.deprecationYears) {
          result.deprecationYears = item.deprecationYears;
        }
        return result;
      } else {
        return payload;
      }
    });
  };
  const getListClients = async (clientId: string | null) => {
    try {
      const response: any = await getClients(0, 0, "", companyId, "");
      setClients(response.data.data);
      if (id !== "new") {
        const client: any = response.data.data.find(
          (value: any) => value.id === clientId,
        );
        setFormValues((prev: any) => ({
          ...prev,
          clientId: client?.id,
          companyId: client?.company?.id,
          companyNumber: client?.company?.companyNumber,
          phoneNumber: client?.phoneNumber,
          taxCode: client?.taxCode,
          businessAddress: [
            client?.companyName,
            client?.addressLine1,
            client?.addressLine2,
            client?.city,
            client?.postalCode,
            client?.countryName,
          ]
            .filter((value) => value != null)
            .join(" , "),
        }));
        setSearchClient(client?.companyName);
      }
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };
  const getListTransactionMonth = async (
    transactionMonthsId: string | null,
  ) => {
    try {
      const response: any = await getTransactionMonth(locationId, companyId);
      setListMonths(response.data);
      if (id !== "new" && transactionMonthsId) {
        const month: any = response.data.find(
          (value: any) => value.id === transactionMonthsId,
        );
        if (month) {
          setSelectedMonth(
            String(month.transactionYear + " - " + month.monthSequence),
          );
          const fromDate = new Date(month.fromDate);
          setFormValues((prev: any) => ({
            ...prev,
            transactionMonthsId: month.id,
            receivedOn: fromDate.toISOString(),
          }));
        }
      } else if (id === "new" && response.data?.length > 0) {
        const sorted = [...response.data].sort(
          (a: any, b: any) =>
            new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime(),
        );
        const month = sorted[0];
        setSelectedMonth(
          String(month.transactionYear + " - " + month.monthSequence),
        );
        const fromDate = new Date(month.fromDate);
        setFormValues((prev: any) => ({
          ...prev,
          transactionMonthsId: month.id,
          receivedOn: fromDate.toISOString(),
        }));
      }
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsClientDropdownOpen(false);
      }
      if (
        dropdownPaymentRef.current &&
        !dropdownPaymentRef.current.contains(event.target as Node)
      ) {
        setIsPaymentDropdownOpen(false);
      }
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsModalOpen(false);
      }
      if (
        paymentRef.current &&
        !paymentRef.current.contains(event.target as Node)
      ) {
        setIsTypeDropdownOpen(false);
      }
      if (
        monthRef.current &&
        !monthRef.current.contains(event.target as Node)
      ) {
        setIsMonthDropdownOpen(false);
      }
      dropdownTaxRef.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target as Node)) {
          setOpenDropdownIndexes((prev) => ({ ...prev, [index]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.addEventListener("mousedown", handleClickOutside);
  }, []);
  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    if (showPayment) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPayment]);

  useEffect(() => {
    if (id !== "new") {
      fetchData(id);
    }
    const handleNewToken = () => {
      if (id !== "new") {
        fetchData(id);
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [id]);
  useEffect(() => {
    if (id === "new") {
      getListClients("");
      getTerms("");
      getListTransactionMonth("");
    }
    getListPayment();
    const handleNewToken = () => {
      if (id === "new") {
        getListClients("");
        getTerms("");
        getListTransactionMonth("");
      }
      getListPayment();
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, []);

  const getListPayment = async () => {
    try {
      const payment: any = await getPaymentType();
      setListPayment(payment?.data?.data);
    } catch (error) {
      console.log("🚀 ~ getListPayment ~ error:", error);
    }
  };

  const getListProductWithId = async (
    dataTax: any,
    dataPurchaseDetails: any,
  ) => {
    try {
      // const response: any = await getListProduct(0, 0, "", companyId);
      // const array: any = response.data.productWithCompany;
      // let allProductPrices: any = array
      //     .flatMap((item: any) => {
      //         return item.productPrices
      //             .map((val: any, index: any) => {
      //                 const product: any = {
      //                     sequenceNo: index,
      //                     recordType: 1,
      //                     articleId: item.id,
      //                     itemName: item.productName,
      //                     quantity: 1,
      //                     price: parseFloat(val.price).toFixed(2),
      //                     discount: 0,
      //                     sku: item.sku,
      //                     net: 0,
      //                     tax: getPrimaryTax(dataTax, val.taxGroupId),
      //                     amount: parseFloat(val.price).toFixed(2),
      //                     cost: parseFloat(val.cost),
      //                     taxId: val.taxGroupId,
      //                     productPriceId: val.id,
      //                     note: '',
      //                     isActive: val.isActive,
      //                     isDeleted: val.isDeleted,
      //                     createdBy: val.createdBy,
      //                     updatedAt: val.updatedAt,
      //                     assetCategoryId: item.assetCategoryId,
      //                     deprecationYears: item.deprecationYears,
      //                     type: item.type,
      //                 };
      //                 if (id !== "new") {
      //                     product.salesId = id;
      //                 }
      //                 return product;
      //             });
      //     });
      // setListProduct(allProductPrices);
      setListTax(dataTax);
      const filteredData = dataPurchaseDetails.filter(
        (record: any) => record.recordType === 1,
      );
      const result = filteredData.reduce(
        (acc: { [key: string]: string }, item: any, index: number) => {
          acc[index.toString()] = item.itemName;
          return acc;
        },
        {},
      );
      setSearchProductPrice(result);
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };
  const fetchData = async (id: string) => {
    webLoadingTrue();
    try {
      const response: any = await getDetailPurchases(id);
      setFormValues({ ...response.data, creditNoteAmount: response.data?.creditNote ? response.data?.creditNote?.remainingAmount : 0 });
      setRows(response?.data?.purchaseDetails);
      getListClients(response.data.clientId);
      getListTransactionMonth(response.data.transactionMonthsId);
      getTerms(response.data.termId);
      const responseTax: any = await getTax(filter);
      setListTax(responseTax?.data);
      getListProductWithId(responseTax?.data, response?.data?.purchaseDetails);
      const filteredData = response?.data?.purchaseDetails.filter(
        (record: any) => record.recordType === 2,
      );
      const taxRateMap = responseTax?.data.reduce(
        (acc: { [key: string]: string }, item: any) => {
          acc[item.id] = item.primaryRate;
          return acc;
        },
        {},
      );

      const result = filteredData.reduce(
        (acc: { [key: string]: string }, item: any, index: number) => {
          const taxId = item.taxId;
          const primaryRate = taxRateMap[taxId];
          if (primaryRate) {
            acc[index.toString()] = primaryRate;
          }
          return acc;
        },
        {},
      );
      setSearchTaxMap(result);
      setFormValuesPayment({
        purchasePayment: response?.data?.purchasePayment,
      });
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      webLoadingFalse();
    }
  };
  const handleSelectType = (type: "product" | "service") => {
    setIsModalOpen(false);
    const isPreviousValid =
      rows.length > 0 &&
      rows[rows.length - 1] &&
      rows[rows.length - 1].sku !== "" &&
      rows[rows.length - 1].itemName !== "" &&
      rows[rows.length - 1].price !== "" &&
      rows[rows.length - 1].tax !== "" &&
      rows[rows.length - 1].discount !== "" &&
      rows[rows.length - 1].amount !== "";
    let newRow: any = {};
    if (type === "product") {
      newRow = {
        sequenceNo: rows.length + 1,
        recordType: 1,
        articleId: "123e4567-e89b-12d3-a456-426614174000",
        quantity: 1,
        price: "",
        sku: "",
        code: "",
        net: 0,
        discount: "",
        tax: "",
        amount: "",
        taxId: "123e4567-e89b-12d3-a456-426614174000",
        productPriceId: "123e4567-e89b-12d3-a456-426614174000",
        note: "",
        isActive: true,
        isDeleted: false,
        createdBy: "123e4567-e89b-12d3-a456-426614174000",
        updatedAt: new Date(),
      };
      if (id !== "new") {
        newRow.salesId = id;
      }
    } else {
      newRow = {
        sequenceNo: rows.length + 1,
        recordType: 2,
        articleId: null,
        quantity: 1,
        price: "",
        sku: "",
        code: "",
        net: 0,
        discount: "",
        tax: "",
        amount: "",
        taxId: "123e4567-e89b-12d3-a456-426614174000",
        productPriceId: "123e4567-e89b-12d3-a456-426614174000",
        note: "",
        isActive: true,
        isDeleted: false,
        createdBy: "123e4567-e89b-12d3-a456-426614174000",
        updatedAt: new Date(),
      };
      if (id !== "new") {
        newRow.salesId = id;
      }
    }
    if (isPreviousValid || rows.length === 0) {
      setRows((prevRows) => [...prevRows, newRow]);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handlePaymentChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValuesPayment({ ...formValuesPayment, [name]: value });
  };

  const handleClientSelect = (client: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      clientId: client?.id,
      companyId: client?.company?.id,
      companyNumber: client?.companyNumber,
      phoneNumber: client?.phoneNumber,
      taxCode: client?.taxCode,
      businessAddress: [
        client?.companyName,
        client?.addressLine1,
        client?.addressLine2,
        client?.city,
        client?.postalCode,
        client?.countryName,
      ]
        .filter((value) => value != null)
        .join(" , "),
    }));
    setSearchClient(client?.companyName);
    setIsClientDropdownOpen(false);
  };

  const calculateServiceTotal = (row: any) => {
    return (
      Number(row.quantity) * Number(row.price) -
      (Number(row.discount) ? Number(row.discount) : 0)
    );
  };
  const handleInputServiceChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: string,
  ) => {
    const value = e.target.value;
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };
      row[field] = value;
      row.amount = calculateServiceTotal(row);
      updatedRows[index] = row;
      return updatedRows;
    });
  };
  const handleBlurServiceChange = (
    e: React.FocusEvent<HTMLInputElement, Element>,
    index: number,
    field: string,
  ) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };
      row[field] = Number(row[field]).toFixed(2);
      updatedRows[index] = row;
      return updatedRows;
    });
  };
  const handlePaymentTypeSelect = (status: any) => {
    setFormValuesPayment((prev: any) => ({
      ...prev,
      type: status.paymentName,
    }));
    setPayemntType(status.paymentName);
    setIsTypeDropdownOpen(false);
  };

  const handleDelete = (index: number) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    setSearchProductPrice((prev: any) => ({ ...prev, [index]: "" }));
  };
  const handleTaxSelect = (tax: any, index: number) => {
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      tax: tax.primaryRate,
      taxId: tax.id,
    };
    setRows(updatedRows);
    setSearchTaxMap((prev: any) => ({ ...prev, [index]: tax.primaryRate }));
    setOpenDropdownIndexes((prev) => ({ ...prev, [index]: false }));
  };

  const handleQuantityChange = (
    index: number,
    type: "increment" | "decrement",
  ) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };

      if (type === "increment") {
        row.quantity += 1;
      } else if (type === "decrement" && row.quantity > 0) {
        row.quantity -= 1;
      }

      row.amount = calculateServiceTotal(row);
      updatedRows[index] = row;

      return updatedRows;
    });
  };
  const handleTaxDropdownToggle = (index: number) => {
    setOpenDropdownIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const calculateTotal = (row: purchaseDetailPayload) => {
    return (
      Number(row.quantity) * Number(row.price) +
      (Number(row.tax)
        ? Number(row.quantity) * Number(row.price) * (Number(row.tax) / 100)
        : 0) -
      (Number(row.discount)
        ? Number(row.quantity) *
        Number(row.price) *
        (Number(row.discount) / 100)
        : 0)
    );
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const newQuantity = Number(e.target.value);

    if (isNaN(newQuantity) || newQuantity < 0) {
      return;
    }

    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };

      row.quantity = newQuantity;
      row.amount = calculateServiceTotal(row);

      updatedRows[index] = row;

      return updatedRows;
    });
  };
  const handleFileChange = async (e: any) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (
      file &&
      (file.type.startsWith("image/") || file.type === "application/pdf")
    ) {
      setFileName(file.name);
      setFileUpload(file);
      try {
        const base64 = await convertToBase64(file);
        if (file.type.startsWith("image/")) {
          setBase64Image(base64);
          setBase64PDF(null);
        } else if (file.type === "application/pdf") {
          setBase64PDF(base64);
          setBase64Image(null);
        }
      } catch (error) {
        console.error("Error converting file:", error);
      }
    } else {
      alert("Please upload an image or PDF file.");
    }
  };

  const handleDrop = async (e: any) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (!file) return;

    if (file.type.startsWith("image/") || file.type === "application/pdf") {
      setFileName(file.name);
      setFileUpload(file);
      try {
        const base64 = await convertToBase64(file);
        if (file.type.startsWith("image/")) {
          setBase64Image(base64);
          setBase64PDF(null);
        } else if (file.type === "application/pdf") {
          setBase64PDF(base64);
          setBase64Image(null);
        }
      } catch (error) {
        console.error("Error converting file:", error);
      }
    } else {
      alert("Please upload a valid image or PDF file.");
    }
  };

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handlePaymentSelect = (payment: any) => {
    setFormValues((prev: any) => ({ ...prev, termId: payment.termId }));
    setPaymentTerm(payment.termName);
    setIsPaymentDropdownOpen(false);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  // Surface a failed save through the shared plain-language error layer: it maps
  // the backend error to a friendly "what happened + what to do" message, applies
  // any field errors, and keeps the endpoint + status as a muted secondary line.
  const showApiError = (error: any, title: string) =>
    showApiErrorToast(error, {
      language,
      titleFallback: title,
      setFieldErrors: (fe) => setErrors((prev: any) => ({ ...prev, ...fe })),
    });
  const handleProductSelect = (product: any, index: any) => {
    const arrayTemp: any = [...rows];
    arrayTemp[index] = { ...product, discount: (0).toFixed(2) };
    setRows(arrayTemp);
    setSearchProductPrice((prev: any) => ({
      ...prev,
      [index]: product.itemName,
    }));
    setIsProductPriceDropdownOpen((prev) => ({ ...prev, [index]: false }));
  };

  const getTaxes = async () => {
    const responseTax = await getTax(filter);
    setListTax(responseTax.data);
    return responseTax.data;
  };

  const handleFormatProductPrices = async (product: any, isFirstPage = false) => {
    let tax: any = {};
    if (isFirstPage) {
      tax = await getTaxes();
    }
    let allProductPrices: any = product.flatMap((item: any, i: any) => {
      return (item.productPrices ?? []).map((val: any, index: any) => {
        const product: any = {
          sequenceNo: index,
          recordType: 1,
          articleId: item.id,
          itemName: item.productName,
          quantity: 1,
          price: parseFloat(val.price).toFixed(2),
          discount: 0,
          sku: item.sku,
          net: 0,
          tax: getPrimaryTax(tax, val.taxGroupId),
          amount: parseFloat(val.price).toFixed(2),
          cost: parseFloat(val.cost),
          taxId: val.taxGroupId,
          productPriceId: val.id,
          note: "",
          isActive: val.isActive,
          isDeleted: val.isDeleted,
          createdBy: val.createdBy,
          updatedAt: val.updatedAt,
          assetCategoryId: item.assetCategoryId,
          deprecationYears: item.deprecationYears,
          type: item.type,
        };
        if (id !== "new") {
          product.salesId = id;
        }
        return product;
      });
    });
    return allProductPrices;
  };

  const productFetch = React.useCallback(
    async ({
      page,
      search,
      limit,
      signal,
    }: {
      page: number;
      search: string;
      limit: number;
      signal?: AbortSignal;
    }) => {
      const res = await getListProduct(page, limit, search, companyId);
      const arr = res?.data?.productWithCompany ?? [];
      const formatted = await handleFormatProductPrices(arr, page === 1);
      if (signal?.aborted) return { data: [], hasMore: false };
      return { data: formatted, hasMore: arr.length >= limit };
    },
    [companyId]
  );
  const asyncProduct = useAsyncDropdown({
    fetchFn: productFetch,
    limit: PAGE_SIZE,
    getItemId: (item: any) => item.productPriceId ?? item.articleId ?? "",
    resetDeps: [companyId],
  });

  const fetchProduct = async (page: any, searchValue: any) => {
    const response: any = await getListProduct(
      page,
      PAGE_SIZE,
      searchValue,
      companyId,
    );
    const array: any = response.data.productWithCompany;
    return array;
  };

  const handleSubmit = async (
    e: React.ChangeEvent<HTMLInputElement>,
    type: string,
  ) => {
    e.preventDefault();
    const newErrors: any = {};
    if (!formValues.clientId) {
      newErrors.clientId = "Seller is required";
    }
    if (!formValues.companyNumber) {
      newErrors.companyNumber = "Company No is required";
    }
    if (!formValues.businessAddress) {
      newErrors.businessAddress = "Business Address is required";
    }
    if (!formValues.transactionMonthsId) {
      newErrors.transactionMonthsId = "Month is required";
    }
    if (!formValues.termId) {
      newErrors.termId = "Payment Term is required";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    if (locationId === "") {
      handleOpenPopup();
      return;
    }
    const payload = {
      ...formValues,
      userId: localStorage.getItem("userId") || "",
      companyId: localStorage.getItem("companyId") || "",
      locationId: localStorage.getItem("locationId") || "",
      clientId: formValues?.clientId,
      entryType: "1",
      purchaseDetail: convertToSaleDetailsPayload(rows),
      type,
      isImport: !!formValues?.isImport,
      customsDuty: formValues?.isImport && formValues?.customsDuty !== "" ? Number(formValues.customsDuty) : null,
      excise: formValues?.isImport && formValues?.excise !== "" ? Number(formValues.excise) : null,
      importVat: formValues?.isImport && formValues?.importVat !== "" ? Number(formValues.importVat) : null,
      customsReference: formValues?.isImport && formValues?.customsReference ? formValues.customsReference : null,
      customsDate: formValues?.isImport && formValues?.customsDate ? formValues.customsDate : null,
      net: parseFloat(
        rows
          .reduce(
            (acc: any, val: any) =>
              acc + Number(val.amount) / (1 + Number(val.tax) / 100),
            0,
          )
          .toFixed(2),
      ),
      tax: parseFloat(
        rows
          .reduce(
            (acc: any, val: any) =>
              acc +
              (Number(val.amount) -
                Number(val.amount) / (1 + Number(val.tax) / 100)),
            0,
          )
          .toFixed(2),
      ),
      isPayment:
        formValuesPayment?.purchasePayment.reduce(
          (acc: any, val: any) => acc + Number(val.amount),
          0,
        ) > 0,
    };
    const formData = new FormData();
    fileName && formData.append("file", fileUpload);
    formData.append("payload", JSON.stringify(payload));
    webLoadingTrue();
    // Payment lines post in parallel; show one error toast per submit.
    let paymentErrorShown = false;
    if (id === "new") {
      try {
        const response: any = await createPurchases(formData);
        if (response?.data?.id) {
          if (
            formValuesPayment?.purchasePayment.reduce(
              (acc: any, val: any) => acc + Number(val.amount),
              0,
            ) > 0
          ) {
            formValuesPayment?.purchasePayment?.map(async (val: any) => {
              const paymentPayload: any = {
                paymentId: response?.data?.id,
                type: val.type,
                reference: val.reference,
                amount: Number(val?.amount),
                transactionMonthsId: formValues?.transactionMonthsId,
                creditNoteAmount: formValues?.creditNoteAmount,
              };
              try {
                const check: any = await createPurchasesPayment(paymentPayload);
                if (check?.data?.id) {
                  webNavigate("/" + preLanguage + "/purchases");
                  webLoadingFalse();
                }
              } catch (error) {
                webLoadingFalse();
                if (!paymentErrorShown) showApiErrorToast(error, { language });
                paymentErrorShown = true;
              }
            });
          } else {
            webNavigate("/" + preLanguage + "/purchases");
            webLoadingFalse();
            showToast({
              message: "Purchases Created !",
              type: "success",
              duration: 20000,
            });
          }
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, "Error creating purchase");
      }
    } else {
      try {
        const response = await updatePurchases(id, formData);
        if (response?.data?.id) {
          if (
            (formValuesPayment?.purchasePayment.length >
              formValues?.purchasePayment.length)
          ) {
            formValuesPayment?.purchasePayment
              .slice(formValues?.purchasePayment.length)
              ?.map(async (val: any) => {
                const paymentPayload: any = {
                  paymentId: response?.data?.id,
                  type: val.type,
                  reference: val.reference,
                  amount: val?.hasCreditValue ? Number(val?.amount) - formValues?.creditNoteAmount : Number(val?.amount),
                  transactionMonthsId: formValues?.transactionMonthsId,
                  creditNoteAmount: val?.hasCreditValue ? formValues?.creditNoteAmount : 0,
                };
                try {
                  const check: any = await createPurchasesPayment(paymentPayload);
                  if (check?.data?.id) {
                    webNavigate("/" + preLanguage + "/purchases");
                    webLoadingFalse();
                  }
                } catch (error) {
                  webLoadingFalse();
                  if (!paymentErrorShown) showApiErrorToast(error, { language });
                  paymentErrorShown = true;
                }
              });
          } else {
            webNavigate("/" + preLanguage + "/purchases");
            showToast({
              message: "Purchases Updated !",
              type: "success",
              duration: 20000,
            });
            webLoadingFalse();
          }
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, "Error updating purchase");
      }
    }
  };

  // Guard the invoice submit against double-clicks creating duplicate purchases.
  const [submitGuarded, submitting] = useSubmitGuard(handleSubmit);

  const handlePayment = async () => {
    const balace: any = (
      (formValuesPayment?.purchasePayment &&
        Array.isArray(formValuesPayment.purchasePayment)
        ? formValuesPayment.purchasePayment.reduce(
          (acc: number, val: any) => acc + (Number(val.amount) || 0),
          0,
        )
        : 0) -
      (Array.isArray(rows) && rows.length > 0
        ? rows.reduce(
          (acc: number, val: any) => acc + (Number(val.amount) || 0),
          0,
        )
        : 0)
    ).toFixed(2);

    if (Number(balace) + Number(formValuesPayment?.value) > 0) {
      setStatusPayment(true);
      setShowPayment(true);
    } else {
      setStatusPayment(false);
      setFormValuesPayment((prevState: any) => {
        const newSalePayment = {
          createdAt: new Date(),
          amount: formValuesPayment?.value,
          reference: formValuesPayment?.reference,
          sale_id: id !== "new" ? id : "",
          type: formValuesPayment?.type,
        };
        const shouldAddPayment = Number(formValuesPayment?.value) > 0;
        return {
          ...prevState,
          value: "0",
          reference: "",
          type: "",
          purchasePayment: shouldAddPayment
            ? [...(prevState.purchasePayment || []), newSalePayment]
            : prevState.purchasePayment,
        };
      });
      setPayemntType("");
      setShowPayment(false);
    }
  };

  const handleDeleteSale = async () => {
    setShowOption({
      type: "",
      check: false,
    });
    webLoadingTrue();
    try {
      const response = await updateStatusPurchases(id, {
        type: showOption?.type === "Cancel" ? "canceled" : "rejected ",
      });
    } catch (error) {
      console.error("Error loading terms:", error);
      showApiErrorToast(error, { language });
    } finally {
      webNavigate("/" + preLanguage + "/purchases");
    }
  };

  const handleResetPayment = () => {
    setShowPayment(false);
    setPayemntType("");
    setFormValuesPayment({
      ...formValuesPayment,
      value: "0",
      reference: "",
      type: "",
    });
  };
  const isRowValid = (row: any) => {
    console.log("🚀 ~ isRowValid ~ row:", row);
    return (
      row &&
      row.sku !== "" &&
      row.itemName !== "" &&
      row.price !== "" &&
      row.tax !== "" &&
      row.discount !== "" &&
      row.amount !== ""
    );
  };
  const isInputValid = (value: any) => {
    return (
      value.invoiceNumber !== "" &&
      value.clientId !== "" &&
      value.companyNumber !== "" &&
      value.businessAddress !== "" &&
      value.transactionMonthsId !== "" &&
      value.termId !== "" &&
      errors?.invoiceNumber === ""
    );
  };
  const handleShowSave = () => {
    const areAllRowsValid = rows.map(isRowValid).every((valid) => valid);
    const isPreviousValid = rows.length > 0 && areAllRowsValid;
    if (isPreviousValid) {
      setShowSave(!showSave);
    }
  };
  useEffect(() => {
    setStateButton(isInputValid(formValues));
  }, [formValues, errors]);
  const handleCheckInvoiceNumber = async () => {
    try {
      if (formValues?.invoiceNumber !== "" && id === "new") {
        const response: any = await checkInvoiceNumber({
          invoiceNumber: formValues?.invoiceNumber,
          companyId: companyId,
        });
        const newErrors: any = {};
        newErrors.invoiceNumber = "";
        setErrors(newErrors);
      }
    } catch (error: any) {
      const newErrors: any = {};
      newErrors.invoiceNumber = error?.response?.data?.message;
      setErrors(newErrors);
    }
  };
  const handleRemoveFile = () => {
    setBase64Image("");
    setBase64PDF("");
    setFileName("");
    setFileUpload(null);
    setFormValues((prev: any) => ({ ...prev, file: null }));
    let inputHoolder = document.getElementById("fileInput") as HTMLInputElement;
    inputHoolder.value = "";
  };

  return (
    <>
      <div className="bg-white">
        <div className="flex items-center ">
          <div
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate("/" + preLanguage + "/purchases");
            }}
          >
            <BackIcon />
          </div>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Back"] ? language?.["Back"] : "Back"}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        {id === "new" ? (
          <p
            style={{
              margin: "20px 0px",
              fontSize: "20px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Add Purchases"]
              ? language?.["Add Purchases"]
              : "Add Purchases"}
          </p>
        ) : (
          <p
            style={{
              margin: "20px 0px",
              fontSize: "20px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Edit Purchases"]
              ? language?.["Edit Purchases"]
              : "Edit Purchases"}
          </p>
        )}
        <div className="flex items-center" style={{ gap: "16px" }}>
          <TagStatus value={formValues?.status?.statusName} />
          <div
            className="cursor-pointer flex items-center"
            style={{
              padding: "8px 16px",
              gap: "8px",
              border: "1px solid #0F7679",
              borderRadius: "30px",
            }}
          >
            <div
              className="flex items-center justify-center"
              style={{ width: "24px", height: "24px" }}
            >
              <PrintIcon />
            </div>
            <p
              className="text-[14px] leading-[22px] font-inter"
              style={{ color: "#0F7679", fontWeight: "500" }}
            >
              {language && language?.["Print"] ? language?.["Print"] : "Print"}
            </p>
          </div>
        </div>
      </div>
      <div className="" style={{ height: "calc(100% - 96px - 67px)" }}>
        <form
          className="scroll-container"
          style={{ height: "100%", overflowY: "scroll", paddingBottom: '16px' }}
        >
          <div
            className=""
            style={{
              padding: "24px",
              border: "1px solid #DBE4E4",
              borderRadius: "12px",
            }}
          >
            <div
              className="flex items-center justify-between"
              style={{ marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}
            >
              <p
                className="text-main font-inter leading-[24px]"
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  margin: 0,
                }}
              >
                {language && language?.["Seller Details"]
                  ? language?.["Seller Details"]
                  : "Seller Details"}
              </p>
              <div className="flex items-center gap-2">
                <span
                  className="text-[14px] font-inter"
                  style={{ color: "#4A5353" }}
                >
                  {language && language?.["Imported goods"]
                    ? language?.["Imported goods"]
                    : "Imported goods"}
                </span>
                <button
                  type="button"
                  role="switch"
                  aria-checked={!!formValues?.isImport}
                  onClick={() => {
                    const next = !formValues?.isImport;
                    setFormValues((prev: any) => ({
                      ...prev,
                      isImport: next,
                      ...(next
                        ? {}
                        : {
                          customsDuty: "",
                          excise: "",
                          importVat: "",
                          customsReference: "",
                          customsDate: null,
                        }),
                    }));
                  }}
                  style={{
                    width: "44px",
                    height: "24px",
                    borderRadius: "12px",
                    border: "none",
                    backgroundColor: formValues?.isImport ? "#0F7679" : "#DBE4E4",
                    cursor: "pointer",
                    position: "relative",
                    transition: "background-color 0.2s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "2px",
                      left: formValues?.isImport ? "22px" : "2px",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      transition: "left 0.2s",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                    }}
                  />
                </button>
              </div>
            </div>
            <div
              className="flex items-start justify-between"
              style={{ gap: "24px", flexWrap: "wrap" }}
            >
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Seller"]
                      ? language?.["Seller"]
                      : "Seller"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13", fontWeight: "500" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="client"
                    refs={{ client: dropdownRef }}
                    openStates={{ client: isClientDropdownOpen }}
                    open={(key) =>
                      key === "client" && setIsClientDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "client" && setIsClientDropdownOpen(false)
                    }
                    data={clients}
                    labelExtractor={(item) => item.companyName}
                    value={searchClient}
                    setValue={setSearchClient}
                    onSelect={handleClientSelect}
                    error={errors.clientId}
                    tabIndex={1}
                  />
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Company No"]
                      ? language?.["Company No"]
                      : "Company No"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13", fontWeight: "500" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={2}
                    type="text"
                    name="companyNumber"
                    onKeyDown={validateNoSpecialCharsOrSpaces}
                    required
                    value={formValues?.companyNumber}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.companyNumber && (
                  <p className="error">{errors.companyNumber}</p>
                )}
              </div>
              <div className="space-y-2" style={{ width: "100%" }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Business Address"]
                      ? language?.["Business Address"]
                      : "Business Address"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13", fontWeight: "500" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <textarea
                    tabIndex={3}
                    value={formValues?.businessAddress}
                    onKeyDown={validateNoSpecialChars}
                    name="businessAddress"
                    style={{ height: "44px" }}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.businessAddress && (
                  <p className="error">{errors.businessAddress}</p>
                )}
              </div>

              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Internal reference"]
                      ? language?.["Internal reference"]
                      : "Internal reference"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13", fontWeight: "500" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    tabIndex={4}
                    name="invoiceNumber"
                    onBlur={() => {
                      handleCheckInvoiceNumber();
                    }}
                    value={formValues?.invoiceNumber}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.invoiceNumber && (
                  <p className="error">{errors.invoiceNumber}</p>
                )}
              </div>

              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Phone Number"]
                      ? language?.["Phone Number"]
                      : "Phone Number"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    tabIndex={5}
                    name="phoneNumber"
                    value={formValues?.phoneNumber}
                    onKeyDown={validateOnlyNumbersNotThree}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.phoneNumber && (
                  <p className="error">{errors.phoneNumber}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Month"]
                      ? language?.["Month"]
                      : "Month"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="month"
                    refs={{ month: monthRef }}
                    openStates={{ month: isMonthDropdownOpen }}
                    open={(key) =>
                      key === "month" && setIsMonthDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "month" && setIsMonthDropdownOpen(false)
                    }
                    data={listMonths}
                    labelExtractor={(item) =>
                      `${item.transactionYear} - ${item.monthSequence}`
                    }
                    value={selectedMonth}
                    setValue={setSelectedMonth}
                    onSelect={handleMonthSelect}
                    error={errors.transactionMonthsId}
                    tabIndex={6}
                  />
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["TAX No"]
                      ? language?.["TAX No"]
                      : "TAX No"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={7}
                    type="text"
                    name="taxCode"
                    onKeyDown={validateNoSpecialCharsOrSpaces}
                    value={formValues?.taxCode}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.taxCode && <p className="error">{errors.taxCode}</p>}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Payment Term"]
                      ? language?.["Payment Term"]
                      : "Payment Term"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="paymentTerm"
                    refs={{ paymentTerm: dropdownPaymentRef }}
                    openStates={{ paymentTerm: isPaymentDropdownOpen }}
                    open={(key) =>
                      key === "paymentTerm" && setIsPaymentDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "paymentTerm" && setIsPaymentDropdownOpen(false)
                    }
                    data={payment}
                    labelExtractor={(item) => item.termName}
                    value={paymentTerm}
                    setValue={setPaymentTerm}
                    onSelect={handlePaymentSelect}
                    error={errors.termId}
                    tabIndex={8}
                  />
                </div>
              </div>
            </div>
          </div>
          <p
            className="text-main font-inter leading-[24px]"
            style={{
              fontSize: "20px",
              fontWeight: "500",
              marginBottom: "12px",
              marginTop: "24px",
            }}
          >
            {language && language?.["Items"] ? language?.["Items"] : "Items"}
          </p>
          <div
            style={{
              border: isMobile ? "none" : "1px solid #DBE4E4",
              borderRadius: "16px",
              marginTop: "12px",
            }}
          >
            {!isMobile && (
              <div
                className="h-10 flex items-center"
                style={{
                  backgroundColor: "#EBF0F0",
                  borderTopRightRadius: "12px",
                  borderTopLeftRadius: "12px",
                }}
              >
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 40}px`,
                  }}
                >
                  <p>
                    {language && language?.["No"] ? language?.["No"] : "No"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 132}px`,
                  }}
                >
                  <p>
                    {language && language?.["Code"]
                      ? language?.["Code"]
                      : "Code"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    flexGrow: 1,
                  }}
                >
                  <p>
                    {language && language?.["Product Name"]
                      ? language?.["Product Name"]
                      : "Product Name"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 110}px`,
                  }}
                >
                  <p>
                    {language && language?.["Quantity"]
                      ? language?.["Quantity"]
                      : "Quantity"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 110}px`,
                  }}
                >
                  <p>
                    {language && language?.["Price"]
                      ? language?.["Price"]
                      : "Price"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 110}px`,
                  }}
                >
                  <p>
                    {language && language?.["Tax"] ? language?.["Tax"] : "Tax"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 110}px`,
                  }}
                >
                  <p>
                    {language && language?.["Discount"]
                      ? language?.["Discount"]
                      : "Discount"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 110}px`,
                  }}
                >
                  <p>
                    {language && language?.["Total"]
                      ? language?.["Total"]
                      : "Total"}
                  </p>
                </div>
                <div
                  className="text-xs font-medium font-inter flex items-center"
                  style={{
                    color: "#6A7878",
                    fontSize: "14px",
                    padding: "0px 12px",
                    width: `${calculatedWidth * 40}px`,
                  }}
                ></div>
              </div>
            )}
            {rows.map((row, index) => {
              if (row.recordType === 1) {
                return (
                  <>
                    {isMobile ? (
                      <div
                        key={index}
                        style={{
                          border: "1px solid #DBE4E4",
                          padding: "16px",
                          borderRadius: "12px",
                          marginBottom: index === row.length - 1 ? "" : "12px",
                        }}
                      >
                        <div
                          className="text-[14px] font-medium leading-[18px] font-inter flex items-center justify-between"
                          style={{
                            color: "#4A5353",
                            width: `100%`,
                          }}
                        >
                          <div>
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["No"]
                                ? language?.["No"]
                                : "No"}
                            </p>
                            <p>{index + 1}</p>
                          </div>

                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div
                              className="text-xs font-inter flex items-center cursor-pointer"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `40px`,
                              }}
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon />
                            </div>
                          ) : (
                            <div
                              className="text-xs font-medium font-inter flex items-center"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `40px`,
                              }}
                            ></div>
                          )}
                        </div>
                        <div
                          className="text-[14px] font-medium leading-[18px] font-inter"
                          style={{
                            color: "#4A5353",
                            width: `100%`,
                            margin: "12px 0",
                          }}
                        >
                          <p style={{ color: "#6A7878", marginBottom: "4px" }}>
                            {language && language?.["Product Name"]
                              ? language?.["Product Name"]
                              : "Product Name"}
                          </p>
                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div
                              className="relative"
                              style={{ width: "100%", height: "100%" }}
                              ref={dropdownProductPriceRef}
                            >
                              <DropdownSearch<{ itemName: string }>
                                refKey={`product-${index}`}
                                placeholder={language && language?.["Enter Product Name"]
                                  ? language?.["Enter Product Name"]
                                  : "Enter Product Name"}
                                refs={{
                                  [`product-${index}`]: dropdownProductPriceRef,
                                }}
                                openStates={{
                                  [`product-${index}`]:
                                    isProductPriceDropdownOpen[index],
                                }}
                                open={() => {
                                  setIsProductPriceDropdownOpen((prev) => ({
                                    ...prev,
                                    [index]: true,
                                  }));
                                  asyncProduct.loadInitial();
                                }}
                                close={() =>
                                  setIsProductPriceDropdownOpen((prev) => ({
                                    ...prev,
                                    [index]: false,
                                  }))
                                }
                                data={asyncProduct.items}
                                labelExtractor={(item) => item.itemName}
                                value={
                                  isProductPriceDropdownOpen[index]
                                    ? asyncProduct.searchTerm
                                    : (rows[index]?.itemName ?? "")
                                }
                                setValue={asyncProduct.setSearchTerm}
                                onSelect={(product) =>
                                  handleProductSelect(product, index)
                                }
                                tabIndex={8}
                                onLoadMore={asyncProduct.loadMore}
                                hasMore={asyncProduct.hasMore}
                                loading={asyncProduct.isLoading}
                                borderNone={false}
                                serverSideSearch
                              />
                            </div>
                          ) : (
                            // ...existing code...
                            <div className="py-2 cursor-pointer text-main">
                              {row?.itemName}
                            </div>
                          )}
                        </div>

                        <div className="flex items-center">
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Quantity"]
                                ? language?.["Quantity"]
                                : "Quantity"}
                            </p>
                            <div
                              className="flex items-center"
                              style={{ gap: "6px" }}
                            >
                              {(id === "new" ||
                                formValues?.status?.statusName === "Draft") && (
                                  <div
                                    className="flex items-center justify-center cursor-pointer"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100%",
                                      backgroundColor: "#EBF0F0",
                                    }}
                                    onClick={() =>
                                      handleQuantityChange(index, "decrement")
                                    }
                                  >
                                    <MinusQuantity />
                                  </div>
                                )}
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                                style={{ width: "29px", height: "22px" }}
                                value={row.quantity}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={validateOnlyNumbers}
                              />
                              {(id === "new" ||
                                formValues?.status?.statusName === "Draft") && (
                                  <div
                                    className="flex items-center justify-center cursor-pointer"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100%",
                                      backgroundColor: "#EBF0F0",
                                    }}
                                    onClick={() =>
                                      handleQuantityChange(index, "increment")
                                    }
                                  >
                                    <PlusQuantity />
                                  </div>
                                )}
                            </div>
                          </div>
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Price"]
                                ? language?.["Price"]
                                : "Price"}
                            </p>
                            <p>
                              {Number(row.price)
                                ? Number(row.price).toFixed(2)
                                : 0}
                            </p>
                          </div>
                        </div>
                        <div
                          className="flex items-center"
                          style={{ margin: "12px 0px" }}
                        >
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["TAX"]
                                ? language?.["TAX"]
                                : "TAX"}
                            </p>
                            <p>
                              {" "}
                              {getPrimaryTax(listTax, row.taxId ?? row.taxGroupId) !==
                                ""
                                  ? getPrimaryTax(
                                      listTax,
                                      row.taxId ?? row.taxGroupId,
                                    )
                                  : Number(row.tax)
                                    ? Number(row.tax).toFixed(2)
                                    : 0}
                            </p>
                          </div>
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Discount"]
                                ? language?.["Discount"]
                                : "Discount"}
                            </p>
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={17}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.discount}
                              placeholder={language && language?.["Enter Discount"]
                                ? language?.["Enter Discount"]
                                : "Enter Discount"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "discount")
                              }
                              onBlur={(e) =>
                                handleBlurServiceChange(e, index, "discount")
                              }
                              onKeyDown={validateDecimalNumer}
                            />
                          </div>
                        </div>
                        <div
                          className="text-[14px] font-medium leading-[18px] font-inter"
                          style={{
                            color: "#4A5353",
                            width: `100%`,
                          }}
                        >
                          <p
                            style={{
                              color: "#6A7878",
                              marginBottom: "4px",
                            }}
                          >
                            {language && language?.["Amount"]
                              ? language?.["Amount"]
                              : "Amount"}
                          </p>
                          <p>
                            €{" "}
                            {Number(row?.amount)
                              ? Number(row?.amount).toFixed(2)
                              : 0}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div
                        key={index}
                        className="h-10 flex items-center"
                        style={{ borderBottom: "1px solid #E7F1F1" }}
                      >
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 40}px`,
                          }}
                        >
                          <p>{index + 1}</p>
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 132}px`,
                          }}
                        >
                          <p>{row?.sku ? row?.sku : ""}</p>
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            flexGrow: 1,
                            height: "100%",
                          }}
                        >
                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div
                              className="relative"
                              style={{ width: "100%", height: "100%" }}
                              ref={dropdownProductPriceRef}
                            >
                              <DropdownSearch<{ itemName: string }>
                                refKey={`product-${index}`}
                                placeholder={language && language?.["Enter Product Name"]
                                  ? language?.["Enter Product Name"]
                                  : "Enter Product Name"}
                                refs={{
                                  [`product-${index}`]: dropdownProductPriceRef,
                                }}
                                openStates={{
                                  [`product-${index}`]:
                                    isProductPriceDropdownOpen[index],
                                }}
                                open={() => {
                                  setIsProductPriceDropdownOpen((prev) => ({
                                    ...prev,
                                    [index]: true,
                                  }));
                                  asyncProduct.loadInitial();
                                }}
                                close={() =>
                                  setIsProductPriceDropdownOpen((prev) => ({
                                    ...prev,
                                    [index]: false,
                                  }))
                                }
                                data={asyncProduct.items}
                                labelExtractor={(item) => item.itemName}
                                value={
                                  isProductPriceDropdownOpen[index]
                                    ? asyncProduct.searchTerm
                                    : (rows[index]?.itemName ?? "")
                                }
                                setValue={asyncProduct.setSearchTerm}
                                onSelect={(product) =>
                                  handleProductSelect(product, index)
                                }
                                tabIndex={8}
                                onLoadMore={asyncProduct.loadMore}
                                hasMore={asyncProduct.hasMore}
                                loading={asyncProduct.isLoading}
                                borderNone={true}
                                serverSideSearch
                              />
                            </div>
                          ) : (
                            // ...existing code...
                            <div className="py-2 cursor-pointer text-main">
                              {row?.itemName}
                            </div>
                          )}
                        </div>

                        <div
                          className="text-xs font-inter flex items-center space-x-1"
                          style={{
                            color: "#6A7878",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          {(id === "new" ||
                            formValues?.status?.statusName === "Draft") && (
                              <div
                                className="flex items-center justify-center cursor-pointer"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100%",
                                  backgroundColor: "#EBF0F0",
                                }}
                                onClick={() =>
                                  handleQuantityChange(index, "decrement")
                                }
                              >
                                <MinusQuantity />
                              </div>
                            )}
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                            style={{ width: "29px", height: "22px" }}
                            value={row.quantity}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={validateOnlyNumbers}
                          />
                          {(id === "new" ||
                            formValues?.status?.statusName === "Draft") && (
                              <div
                                className="flex items-center justify-center cursor-pointer"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100%",
                                  backgroundColor: "#EBF0F0",
                                }}
                                onClick={() =>
                                  handleQuantityChange(index, "increment")
                                }
                              >
                                <PlusQuantity />
                              </div>
                            )}
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <p>
                            {Number(row.price)
                              ? Number(row.price).toFixed(2)
                              : 0}
                          </p>
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <p>
                            {" "}
                            {getPrimaryTax(listTax, row.taxId ?? row.taxGroupId) !==
                                ""
                                  ? getPrimaryTax(
                                      listTax,
                                      row.taxId ?? row.taxGroupId,
                                    )
                                  : Number(row.tax)
                                    ? Number(row.tax).toFixed(2)
                                    : 0}
                          </p>
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            tabIndex={17}
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                            style={{ width: "100%", height: "22px" }}
                            value={row.discount}
                            placeholder={language && language?.["Enter Discount"]
                              ? language?.["Enter Discount"]
                              : "Enter Discount"}
                            onChange={(e) =>
                              handleInputServiceChange(e, index, "discount")
                            }
                            onBlur={(e) =>
                              handleBlurServiceChange(e, index, "discount")
                            }
                            onKeyDown={validateDecimalNumer}
                          />
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <p>
                            €{" "}
                            {Number(row?.amount)
                              ? Number(row?.amount).toFixed(2)
                              : 0}
                          </p>
                        </div>
                        {id === "new" ||
                          formValues?.status?.statusName === "Draft" ? (
                          <div
                            className="text-xs font-inter flex items-center cursor-pointer"
                            style={{
                              color: "#6A7878",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 40}px`,
                            }}
                            onClick={() => handleDelete(index)}
                          >
                            <DeleteIcon />
                          </div>
                        ) : (
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 40}px`,
                            }}
                          ></div>
                        )}
                      </div>
                    )}
                  </>
                );
              } else {
                return (
                  <>
                    {isMobile ? (
                      <div
                        key={index}
                        style={{
                          border: "1px solid #DBE4E4",
                          padding: "16px",
                          borderRadius: "12px",
                          marginBottom: index === row.length - 1 ? "" : "12px",
                        }}
                      >
                        <div
                          className="text-[14px] font-medium leading-[18px] font-inter flex items-center justify-between"
                          style={{
                            color: "#4A5353",
                            width: `100%`,
                          }}
                        >
                          <div>
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["No"]
                                ? language?.["No"]
                                : "No"}
                            </p>
                            <p>{index + 1}</p>
                          </div>

                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div
                              className="text-xs font-inter flex items-center cursor-pointer"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `40px`,
                              }}
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon />
                            </div>
                          ) : (
                            <div
                              className="text-xs font-medium font-inter flex items-center"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `40px`,
                              }}
                            ></div>
                          )}
                        </div>
                        <div
                          className="flex items-center"
                          style={{
                            margin: "12px 0",
                          }}
                        >
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["SKU"]
                                ? language?.["SKU"]
                                : "SKU"}
                            </p>
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={12}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.sku}
                              placeholder={language && language?.["Enter SKU"]
                                ? language?.["Enter SKU"]
                                : "Enter SKU"}
                              onKeyDown={validateNoSpecialCharsOrSpaces}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "sku")
                              }
                            />
                          </div>

                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Product Name"]
                                ? language?.["Product Name"]
                                : "Product Name"}
                            </p>
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={13}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.itemName}
                              placeholder={language && language?.["Enter Product Name"]
                                ? language?.["Enter Product Name"]
                                : "Enter Product Name"}
                              onKeyDown={validateNoSpecialChars}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "itemName")
                              }
                            />
                          </div>
                        </div>
                        <div className="flex items-center">
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Quantity"]
                                ? language?.["Quantity"]
                                : "Quantity"}
                            </p>
                            <div
                              className="flex items-center"
                              style={{ gap: "6px" }}
                            >
                              {(id === "new" ||
                                formValues?.status?.statusName === "Draft") && (
                                  <div
                                    className="flex items-center justify-center cursor-pointer"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100%",
                                      backgroundColor: "#EBF0F0",
                                    }}
                                    onClick={() =>
                                      handleQuantityChange(index, "decrement")
                                    }
                                  >
                                    <MinusQuantity />
                                  </div>
                                )}
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                                style={{ width: "29px", height: "22px" }}
                                value={row.quantity}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={validateOnlyNumbers}
                              />
                              {(id === "new" ||
                                formValues?.status?.statusName === "Draft") && (
                                  <div
                                    className="flex items-center justify-center cursor-pointer"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100%",
                                      backgroundColor: "#EBF0F0",
                                    }}
                                    onClick={() =>
                                      handleQuantityChange(index, "increment")
                                    }
                                  >
                                    <PlusQuantity />
                                  </div>
                                )}
                            </div>
                          </div>
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Price"]
                                ? language?.["Price"]
                                : "Price"}
                            </p>
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={15}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.price}
                              placeholder={language && language?.["Enter Price"]
                                ? language?.["Enter Price"]
                                : "Enter Price"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "price")
                              }
                              onBlur={(e) =>
                                handleBlurServiceChange(e, index, "price")
                              }
                              onKeyDown={validateDecimalNumer}
                            />
                          </div>
                        </div>
                        <div className="flex items-center">
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["TAX"]
                                ? language?.["TAX"]
                                : "TAX"}
                            </p>
                            {id === "new" ||
                              formValues?.status?.statusName === "Draft" ? (
                              <div className="relative">
                                <input
                                  type="text"
                                  placeholder="Selecct TAX"
                                  disabled={
                                    id !== "new" &&
                                    formValues?.status?.statusName !== "Draft"
                                  }
                                  onKeyDown={validateNoSpecialChars}
                                  tabIndex={16}
                                  value={
                                    searchTaxMap[index] !== undefined
                                      ? searchTaxMap[index]
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    setSearchTaxMap((prev: any) => ({
                                      ...prev,
                                      [index]: newValue,
                                    }));

                                    setOpenDropdownIndexes((prev) => ({
                                      ...prev,
                                      [index]: true,
                                    }));
                                  }}
                                  onClick={() => handleTaxDropdownToggle(index)}
                                  className={`text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center outline-none focus:none bg-transparent`}
                                />

                                {openDropdownIndexes[index] && (
                                  <div
                                    className="absolute z-10 mt-1 bg-white rounded-lg max-h-60 overflow-auto p-1 shadow-extend"
                                    style={{ width: "200px" }}
                                  >
                                    {listTax.filter((tax: any) =>
                                      (tax?.primaryRate?.toString() ?? "")
                                        .toLowerCase()
                                        .includes((searchTaxMap[index] ?? "").toLowerCase())
                                    ).length === 0 ? (
                                      <div style={{ padding: "12px 0px" }}>
                                        <p className="text-[14px] font-inter leading-[20px] text-black text-center">
                                          {language &&
                                            language?.["No tax available"]
                                            ? language?.["No tax available"]
                                            : "No tax available"}
                                        </p>
                                        <p
                                          onClick={() => {
                                            webRoute("Configurations/tax");
                                          }}
                                          style={{
                                            marginTop: "12px",
                                            color: "#078D91",
                                          }}
                                          className="text-[14px] font-inter leading-[20px] text-center cursor-pointer"
                                        >
                                          {language &&
                                            language?.["Add as new tax?"]
                                            ? language?.["Add as new tax?"]
                                            : "Add as new tax?"}
                                        </p>
                                      </div>
                                    ) : (
                                      listTax.map((tax: any) => (
                                        <div
                                          key={tax.id}
                                          className="px-4 py-2 cursor-pointer text-main"
                                          onClick={() =>
                                            handleTaxSelect(tax, index)
                                          }
                                        >
                                          {tax.primaryRate}
                                        </div>
                                      ))
                                    )}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="py-2 cursor-pointer text-main">
                                {
                                  listTax?.find((v: any) => v.id === row.taxGroupId)
                                    ?.primaryRate
                                }
                              </div>
                            )}
                          </div>

                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `calc(50% - 12px)`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Discount"]
                                ? language?.["Discount"]
                                : "Discount"}
                            </p>
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={17}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.discount}
                              placeholder={language && language?.["Enter Discount"]
                                ? language?.["Enter Discount"]
                                : "Product Name"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "discount")
                              }
                              onBlur={(e) =>
                                handleBlurServiceChange(e, index, "discount")
                              }
                              onKeyDown={validateDecimalNumer}
                            />
                          </div>
                        </div>
                        <div
                          className="text-[14px] font-medium leading-[18px] font-inter"
                          style={{
                            color: "#4A5353",
                            width: `100%`,
                          }}
                        >
                          <p
                            style={{
                              color: "#6A7878",
                              marginBottom: "4px",
                            }}
                          >
                            {language && language?.["Amount"]
                              ? language?.["Amount"]
                              : "Amount"}
                          </p>
                          <p>
                            €{" "}
                            {Number(row?.amount)
                              ? Number(row?.amount).toFixed(2)
                              : 0}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div
                        key={index}
                        className="h-10 flex items-center"
                        style={{ borderBottom: "1px solid #E7F1F1" }}
                      >
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 40}px`,
                          }}
                        >
                          <p>{index + 1}</p>
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 132}px`,
                          }}
                        >
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            tabIndex={12}
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                            style={{ width: "100%", height: "22px" }}
                            value={row.sku}
                            placeholder={language && language?.["Enter SKU"]
                              ? language?.["Enter SKU"]
                              : "Enter SKU"}
                            onKeyDown={validateNoSpecialCharsOrSpaces}
                            onChange={(e) =>
                              handleInputServiceChange(e, index, "sku")
                            }
                          />
                        </div>

                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            flexGrow: 1,
                          }}
                        >
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            tabIndex={13}
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                            style={{ width: "100%", height: "22px" }}
                            value={row.itemName}
                            onKeyDown={validateNoSpecialChars}
                            placeholder={language && language?.["Enter Product Name"]
                              ? language?.["Enter Product Name"]
                              : "Enter Product Name"}
                            onChange={(e) =>
                              handleInputServiceChange(e, index, "itemName")
                            }
                          />
                        </div>
                        <div
                          className="text-xs font-inter flex items-center space-x-1"
                          style={{
                            color: "#6A7878",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          {(id === "new" ||
                            formValues?.status?.statusName === "Draft") && (
                              <div
                                className="flex items-center justify-center cursor-pointer"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100%",
                                  backgroundColor: "#E7F1F1",
                                }}
                                onClick={() =>
                                  handleQuantityChange(index, "decrement")
                                }
                              >
                                <MinusQuantity />
                              </div>
                            )}
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            tabIndex={14}
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                            style={{ width: "29px", height: "22px" }}
                            value={row.quantity}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={validateOnlyNumbers}
                          />
                          {(id === "new" ||
                            formValues?.status?.statusName === "Draft") && (
                              <div
                                className="flex items-center justify-center cursor-pointer"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100%",
                                  backgroundColor: "#E7F1F1",
                                }}
                                onClick={() =>
                                  handleQuantityChange(index, "increment")
                                }
                              >
                                <PlusQuantity />
                              </div>
                            )}
                        </div>
                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            tabIndex={15}
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                            style={{ width: "100%", height: "22px" }}
                            value={row.price}
                            placeholder={language && language?.["Enter Price"]
                              ? language?.["Enter Price"]
                              : "Enter Price"}
                            onChange={(e) =>
                              handleInputServiceChange(e, index, "price")
                            }
                            onBlur={(e) =>
                              handleBlurServiceChange(e, index, "price")
                            }
                            onKeyDown={validateDecimalNumer}
                          />
                        </div>

                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div className="relative">
                              <input
                                type="text"
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                onKeyDown={validateNoSpecialChars}
                                tabIndex={16}
                                value={
                                  searchTaxMap[index] !== undefined
                                    ? searchTaxMap[index]
                                    : ""
                                }
                                placeholder={language && language?.["Select TAX"]
                                  ? language?.["Select TAX"]
                                  : "Select TAX"}
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  setSearchTaxMap((prev: any) => ({
                                    ...prev,
                                    [index]: newValue,
                                  }));

                                  setOpenDropdownIndexes((prev) => ({
                                    ...prev,
                                    [index]: true,
                                  }));
                                }}
                                onClick={() => handleTaxDropdownToggle(index)}
                                className={`text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center outline-none focus:none bg-transparent`}
                              />

                              {openDropdownIndexes[index] && (
                                <div
                                  className="absolute z-10 mt-1 bg-white rounded-lg max-h-60 overflow-auto p-1 shadow-extend"
                                  style={{ width: "200px" }}
                                >
                                  {listTax.filter((tax: any) =>
                                    (tax?.primaryRate?.toString() ?? "")
                                      .toLowerCase()
                                      .includes((searchTaxMap[index] ?? "").toLowerCase())
                                  ).length === 0 ? (
                                    <div style={{ padding: "12px 0px" }}>
                                      <p className="text-[14px] font-inter leading-[20px] text-black text-center">
                                        {language &&
                                          language?.["No tax available"]
                                          ? language?.["No tax available"]
                                          : "No tax available"}
                                      </p>
                                      <p
                                        onClick={() => {
                                          webRoute("Configurations/tax");
                                        }}
                                        style={{
                                          marginTop: "12px",
                                          color: "#078D91",
                                        }}
                                        className="text-[14px] font-inter leading-[20px] text-center cursor-pointer"
                                      >
                                        {language &&
                                          language?.["Add as new tax?"]
                                          ? language?.["Add as new tax?"]
                                          : "Add as new tax?"}
                                      </p>
                                    </div>
                                  ) : (
                                    listTax.map((tax: any) => (
                                      <div
                                        key={tax.id}
                                        className="px-4 py-2 cursor-pointer text-main"
                                        onClick={() =>
                                          handleTaxSelect(tax, index)
                                        }
                                      >
                                        {tax.primaryRate}
                                      </div>
                                    ))
                                  )}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="py-2 cursor-pointer text-main">
                              {
                                listTax?.find((v: any) => v.id === row.taxGroupId)
                                  ?.primaryRate
                              }
                            </div>
                          )}
                        </div>

                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <input
                            disabled={
                              id !== "new" &&
                              formValues?.status?.statusName !== "Draft"
                            }
                            tabIndex={17}
                            className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                            style={{ width: "100%", height: "22px" }}
                            value={row.discount}
                            placeholder={language && language?.["Enter Discount"]
                              ? language?.["Enter Discount"]
                              : "Enter Discount"}
                            onChange={(e) =>
                              handleInputServiceChange(e, index, "discount")
                            }
                            onBlur={(e) =>
                              handleBlurServiceChange(e, index, "discount")
                            }
                            onKeyDown={validateDecimalNumer}
                          />
                        </div>

                        <div
                          className="text-xs font-medium font-inter flex items-center"
                          style={{
                            color: "#6A7878",
                            fontSize: "14px",
                            padding: "0px 12px",
                            width: `${calculatedWidth * 110}px`,
                          }}
                        >
                          <p>
                            €{" "}
                            {Number(row?.amount)
                              ? Number(row?.amount).toFixed(2)
                              : 0}
                          </p>
                        </div>

                        {id === "new" ||
                          formValues?.status?.statusName === "Draft" ? (
                          <div
                            className="text-xs font-inter flex items-center cursor-pointer"
                            style={{
                              color: "#6A7878",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 40}px`,
                            }}
                            onClick={() => handleDelete(index)}
                          >
                            <DeleteIcon />
                          </div>
                        ) : (
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 40}px`,
                            }}
                          ></div>
                        )}
                      </div>
                    )}
                  </>
                );
              }
            })}
            {(id === "new" || formValues?.status?.statusName === "Draft") && (
              <div className="h-10 relative" style={{}}>
                {isMobile ? (
                  <div
                    onClick={addRow}
                    className="h-full flex items-center relative cursor-pointer"
                    style={{
                      gap: "6px",
                      padding: "0px 12px",
                      width: "100%",
                      backgroundColor: "#EBF0F0",
                      borderRadius: "12px",
                      marginTop: "12px",
                    }}
                  >
                    <div
                      className="flex items-center justify-center"
                      style={{ width: "24px", height: "24px" }}
                    >
                      <PlusGreenIcon />
                    </div>
                    <p
                      className="text-[14px] font-inter leading-[20px] font-medium"
                      style={{ color: "#0F7679 " }}
                    >
                      {language && language?.["Add"]
                        ? language?.["Add"]
                        : "Add"}
                    </p>
                  </div>
                ) : (
                  <div
                    onClick={addRow}
                    className="h-full flex items-center relative cursor-pointer"
                    style={{
                      gap: "6px",
                      padding: "0px 12px",
                      width: "fit-content",
                    }}
                  >
                    <div
                      className="flex items-center justify-center"
                      style={{ width: "24px", height: "24px" }}
                    >
                      <PlusGreenIcon />
                    </div>
                    <p
                      className="text-[14px] font-inter leading-[20px] font-medium"
                      style={{ color: "#0F7679 " }}
                    >
                      {language && language?.["Add"]
                        ? language?.["Add"]
                        : "Add"}
                    </p>
                  </div>
                )}
                {isModalOpen && (
                  <div
                    ref={popupRef}
                    className="absolute rounded-lg bg-white shadow-extend space-y-1"
                    style={{
                      width: "120px",
                      left: "8px",
                      top: "36px",
                      padding: "4px",
                    }}
                  >
                    <div
                      onClick={() => handleSelectType("product")}
                      className="add_hover cursor-pointer duration-300 text-[14px] leading-[20px] text-main font-inter"
                      style={{ padding: "8px 6px", borderRadius: "4px" }}
                    >
                      {language && language?.["Product"]
                        ? language?.["Product"]
                        : "Product"}
                    </div>
                    <div
                      onClick={() => handleSelectType("service")}
                      className="add_hover cursor-pointer duration-300 text-[14px] leading-[20px] text-main font-inter"
                      style={{ padding: "8px 6px", borderRadius: "4px" }}
                    >
                      {language && language?.["Service"]
                        ? language?.["Service"]
                        : "Service"}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {formValues?.isImport && (
            <div
              className=""
              style={{
                width: "100%",
                marginTop: "24px",
                marginBottom: "24px",
                padding: "24px",
                border: "1px solid #DBE4E4",
                borderRadius: "12px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <p
                className="text-main font-inter leading-[24px]"
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  marginBottom: "24px",
                }}
              >
                {language && language?.["Import detail"]
                  ? language?.["Import detail"]
                  : "Import detail"}
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gap: "24px",
                  marginBottom: "24px",
                }}
              >
                <div className="space-y-2">
                  <p className="text-[14px] font-inter" style={{ color: "#4A5353" }}>
                    {language && language?.["Customs duty"] ? language?.["Customs duty"] : "Customs duty"}
                  </p>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    name="customsDuty"
                    value={formValues?.customsDuty ?? ""}
                    onChange={(e: any) => handleChange(e)}
                    placeholder="0.00"
                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                  />
                </div>
                <div className="space-y-2">
                  <p className="text-[14px] font-inter" style={{ color: "#4A5353" }}>
                    {language && language?.["Excise"] ? language?.["Excise"] : "Excise"}
                  </p>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    name="excise"
                    value={formValues?.excise ?? ""}
                    onChange={(e: any) => handleChange(e)}
                    placeholder="0.00"
                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                  />
                </div>
                <div className="space-y-2">
                  <p className="text-[14px] font-inter" style={{ color: "#4A5353" }}>
                    {language && language?.["Import tax"] ? language?.["Import tax"] : "Import tax"}
                  </p>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    name="importVat"
                    value={formValues?.importVat ?? ""}
                    onChange={(e: any) => handleChange(e)}
                    placeholder="0.00"
                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                  />
                </div>
                <div className="space-y-2">
                  <p className="text-[14px] font-inter" style={{ color: "#4A5353" }}>
                    {language && language?.["Total"] ? language?.["Total"] : "Total"}
                  </p>
                  <p className="text-[14px] font-inter text-main border border-transparent p-3 rounded-xl w-full">
                    €
                    {(
                      (Number(formValues?.customsDuty) || 0) +
                      (Number(formValues?.excise) || 0) +
                      (Number(formValues?.importVat) || 0)
                    ).toFixed(2)}
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gap: "24px",
                }}
              >
                <div className="space-y-2">
                  <p className="text-[14px] font-inter" style={{ color: "#4A5353" }}>
                    {language && language?.["Customs reference"] ? language?.["Customs reference"] : "Customs reference"}
                  </p>
                  <input
                    type="text"
                    name="customsReference"
                    value={formValues?.customsReference ?? ""}
                    onChange={(e: any) => handleChange(e)}
                    placeholder={language && language?.["Enter reference here"] ? language?.["Enter reference here"] : "Enter reference here"}
                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                  />
                </div>
                <div className="space-y-2">
                  <p className="text-[14px] font-inter" style={{ color: "#4A5353" }}>
                    {language && language?.["Customs import date"] ? language?.["Customs import date"] : "Customs import date"}
                  </p>
                  <DatePicker
                    selected={formValues?.customsDate ? new Date(formValues.customsDate) : null}
                    onChange={(date: Date | null) =>
                      setFormValues((prev: any) => ({
                        ...prev,
                        customsDate: date ? date.toISOString().split("T")[0] : null,
                      }))
                    }
                    placeholderText={language && language?.["Select a date"] ? language?.["Select a date"] : "Select a date"}
                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                    dateFormat="yyyy-MM-dd"
                  />
                </div>
              </div>
            </div>
          )}
          <div className="">
            <div className="" style={{ width: "100%", marginBottom: "24px" }}>
              <div
                className="w-full flex items-center justify-center"
                style={{
                  marginTop: "24px",
                  padding: "32px 24px",
                  backgroundColor: "#FFFFFF",
                  border: `1px dashed ${isDragging ? "#3AC0C4" : "#DBE4E4"}`,
                  borderRadius: "12px",
                }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
              >
                <div className="space-y-2 text-center">
                  <div className="flex items-center justify-center">
                    <UploadIconV2 />
                  </div>

                  {base64Image || base64PDF || formValues?.file ? (
                    <div
                      className="flex items-center justify-center"
                      style={{ gap: "24px" }}
                    >
                      <p
                        className="text-[14px] font-inter  font-semibold leading-[18px] cursor-pointer"
                        style={{ color: "#0F7679", marginTop: "8px" }}
                        onClick={() => {
                          setShowPopupImage(true);
                        }}
                      >
                        View Files
                      </p>
                      <p
                        className="text-[14px] font-inter  font-semibold leading-[18px] cursor-pointer"
                        style={{ color: "#0F7679", marginTop: "8px" }}
                        onClick={() => {
                          handleRemoveFile();
                        }}
                      >
                        Remove FIle
                      </p>
                    </div>
                  ) : (
                    <label
                      htmlFor="fileInput"
                      className="text-[14px] font-inter  font-semibold leading-[18px] cursor-pointer"
                      style={{ color: "#0F7679", marginTop: "8px" }}
                    >
                      Upload Files
                      {(!base64Image || !base64PDF || formValues?.file) && (
                        <span
                          className="text-[14px] text-main leading-[20px] font-inter"
                          style={{ color: "#4A5353", marginLeft: "2px" }}
                        >
                          {fileName
                            ? `File: ${fileName}`
                            : language && language?.[" or drag & drop here"]
                              ? language?.[" or drag & drop here"]
                              : " or drag & drop here"}
                        </span>
                      )}
                    </label>
                  )}
                  <p
                    style={{ fontSize: "12px", color: "#6A7878" }}
                    className="leading-[22px] font-inter"
                  >
                    {language && language?.["PNG, JPG up to 10MB"]
                      ? language?.["PNG, JPG up to 10MB"]
                      : "PNG, JPG up to 10MB"}
                  </p>

                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    id="fileInput"
                  />
                </div>
              </div>
            </div>
            <div className="" style={{ width: "100%", marginBottom: "24px" }}>
              <p
                className="text-[14px] font-inter leading-[20px]"
                style={{ color: "#4A5353" }}
              >
                {language && language?.["Description"]
                  ? language?.["Description"]
                  : "Description"}
              </p>
              <textarea
                tabIndex={10}
                style={{ height: "134px", marginTop: "6px" }}
                // Notes are free text: allow normal punctuation (. , ' etc.) and
                // only block characters that could break rendering or storage.
                onKeyDown={(e) => {
                  if (["<", ">", "{", "}", "\\"].includes(e.key))
                    e.preventDefault();
                }}
                name="note"
                value={formValues?.note}
                onChange={(e: any) => {
                  handleChange(e);
                }}
                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg  outline-none focus-none bg-white w-full`}
              />
            </div>
            <div
              className="flex items-start"
              style={{ gap: "24px", flexWrap: "wrap" }}
            >
            <div
              className=""
              style={{
                width: isMobile ? "100%" : "calc(50% - 12px)",
                overflow: "hidden",
                height: "fit-content",
              }}
            >
              {/* {formValuesPayment?.salePayment?.map((v: any) => {
                  return (
                    <div
                      className="flex items-center justify-between border-b border-[#EBEBED] text-[12px] text-main leading-[17px] font-inter"
                      style={{
                        backgroundColor: "white",
                        height: "40px",
                        padding: "0px 12px",
                      }}
                    >
                      <p style={{ fontSize: "12px" }}>
                        {language && language?.["Subtotal"]
                          ? language?.["Subtotal"]
                          : "Subtotal"}
                        <span className="text-body ml-1">
                          {formatDate(v?.createdAt)}
                        </span>
                      </p>
                      <p>{v?.amount ? Number(v?.amount).toFixed(2) : 0} € </p>
                    </div>
                  );
                })} */}

              <div
                className="flex items-center justify-between"
                style={{
                  padding: "24px",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  border: "1px solid #DBE4E4",
                }}
              >
                <div className="flex items-center gap-x-2">
                  <div
                    className="flex items-center justify-center"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <BalanceIcon />
                  </div>
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#222525",
                      fontWeight: "500",
                    }}
                    className=" font-inter"
                  >
                    {language && language?.["BALANCE"]
                      ? language?.["BALANCE"]
                      : "BALANCE"}
                  </p>
                </div>
                <p
                  className=" font-inter"
                  style={{ fontSize: "16px", color: "#6A7878" }}
                >
                  €
                  {(
                    (Array.isArray(rows) && rows.length > 0
                      ? rows.reduce(
                        (acc: number, val: any) =>
                          acc + (Number(val.amount) || 0),
                        0,
                      )
                      : 0) -
                    (formValuesPayment?.purchasePayment &&
                      Array.isArray(formValuesPayment.purchasePayment)
                      ? formValuesPayment.purchasePayment.reduce(
                        (acc: number, val: any) =>
                          acc + (Number(val.amount) || 0),
                        0,
                      )
                      : 0)
                  ).toFixed(2) || "0.00"}{" "}
                </p>
              </div>
              {formValuesPayment?.purchasePayment &&
                Array.isArray(formValuesPayment.purchasePayment) &&
                formValuesPayment.purchasePayment.length > 0 && (
                  <div
                    style={{
                      borderLeft: "1px solid #DBE4E4",
                      borderRight: "1px solid #DBE4E4",
                      padding: "12px 24px",
                    }}
                  >
                    {formValuesPayment.purchasePayment.map((payment: any, index: number) => (
                      <div
                        key={payment?.id ?? index}
                        className="flex items-center justify-between font-inter"
                        style={{
                          fontSize: "14px",
                          color: "#4A5353",
                          padding: "6px 0",
                        }}
                      >
                        <span>
                          {(language?.["Payment"] ?? "Payment")} {index + 1}
                          {" – "}
                          {payment?.createdAt
                            ? formatDate(payment.createdAt)
                            : "–"}
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {payment?.amount != null
                            ? Number(payment.amount).toFixed(2)
                            : "0.00"}{" "}
                          €
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              <div
                className="flex items-center justify-center gap-x-1 cursor-pointer"
                style={{
                  backgroundColor: "#EBF0F0",
                  height: "40px",
                  padding: "8px 0px",
                  border: "1px solid transparent",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                }}
                onClick={() => {
                  setShowPayment(true);
                }}
              >
                <PlusGreenIcon />
                <p
                  className="text-[14px] leading-[22px] font-inter"
                  style={{ color: "#0F7679", fontWeight: "500" }}
                >
                  {language && language?.["Add new payment"]
                    ? language?.["Add new payment"]
                    : "Add new payment"}
                </p>
              </div>
            </div>
            {/* Totals summary — net subtotal, VAT, discount and the dominant
                grand total, mirroring the sales invoice summary. `tax` is the
                rate per line, so subtotal = amount / (1 + tax/100). */}
            <div
              style={{
                width: isMobile ? "100%" : "calc(50% - 12px)",
                overflow: "hidden",
                height: "fit-content",
              }}
            >
              <div
                style={{
                  padding: "24px",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  border: "1px solid #DBE4E4",
                }}
              >
                <div
                  className="flex items-center justify-between"
                  style={{ backgroundColor: "white", height: "36px" }}
                >
                  <p
                    style={{ fontSize: "14px", color: "#000000", fontWeight: "500" }}
                    className="font-inter"
                  >
                    {language && language?.["Subtotal"]
                      ? language?.["Subtotal"]
                      : "Subtotal"}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#4A5353",
                      fontWeight: "500",
                      fontVariantNumeric: "tabular-nums",
                    }}
                    className="text-main leading-[17px] font-inter"
                  >
                    {rows
                      .reduce(
                        (acc: any, val: any) =>
                          acc +
                          Number(val.amount) / (1 + Number(val.tax) / 100),
                        0,
                      )
                      .toFixed(2)}{" "}
                    €
                  </p>
                </div>
                <div
                  className="flex items-center justify-between"
                  style={{ backgroundColor: "white", height: "36px" }}
                >
                  <p
                    style={{ fontSize: "14px", color: "black", fontWeight: "500" }}
                    className="text-main leading-[17px] font-inter"
                  >
                    {language && language?.["Tax"] ? language?.["Tax"] : "Tax"}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#4A5353",
                      fontWeight: "500",
                      fontVariantNumeric: "tabular-nums",
                    }}
                    className="text-main leading-[17px] font-inter"
                  >
                    {rows
                      .reduce(
                        (acc: any, val: any) =>
                          acc +
                          (Number(val.amount) -
                            Number(val.amount) / (1 + Number(val.tax) / 100)),
                        0,
                      )
                      .toFixed(2)}{" "}
                    €
                  </p>
                </div>
                <div
                  className="flex items-center justify-between"
                  style={{ backgroundColor: "white", height: "36px" }}
                >
                  <p
                    style={{ fontSize: "14px", color: "black", fontWeight: "500" }}
                    className="text-main leading-[17px] font-inter"
                  >
                    {language && language?.["Discount"]
                      ? language?.["Discount"]
                      : "Discount"}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#4A5353",
                      fontWeight: "500",
                      fontVariantNumeric: "tabular-nums",
                    }}
                    className="text-main leading-[17px] font-inter"
                  >
                    {rows
                      .reduce(
                        (acc: any, val: any) => acc + Number(val.discount),
                        0,
                      )
                      .toFixed(2)}{" "}
                    €
                  </p>
                </div>
              </div>
              <div
                className="flex items-center justify-between border-b border-[#EBEBED] "
                style={{
                  backgroundColor: "#EBF0F0",
                  padding: "16px",
                  border: "1px solid transparent",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                }}
              >
                <p
                  style={{ fontSize: "16px", fontWeight: "600", color: "#222525" }}
                  className="text-main leading-[24px] font-inter"
                >
                  {language && language?.["TOTAL"]
                    ? language?.["TOTAL"]
                    : "TOTAL"}
                </p>
                <p
                  style={{
                    fontSize: "20px",
                    color: "#222525",
                    fontWeight: "700",
                    fontVariantNumeric: "tabular-nums",
                  }}
                  className="text-main leading-[24px] font-inter"
                >
                  {rows
                    .reduce(
                      (acc: any, val: any) => acc + Number(val.amount),
                      0,
                    )
                    .toFixed(2)}{" "}
                  €
                </p>
              </div>
            </div>
            </div>
          </div>
          <div
            className={`fixed inset-0 flex items-end justify-end duration-300`}
            style={{
              height: "100vh",
              width: "100vw",
              backgroundColor: "#22252552",
              top: 0,
              left: 0,
              opacity: showPayment ? 1 : 0,
              zIndex: "200",
              pointerEvents: showPayment ? "auto" : "none",
            }}
            // Click the dimmed backdrop (outside the panel) to dismiss.
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowPayment(false);
            }}
          >
            <div
              style={{
                width: isMobile ? "90%" : "30%",
                height: "100%",
                padding: "24px",
                backgroundColor: "#FFFFFF",
                transform: showPayment ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)",
              }}
              className="shadow_panel "
            >
              <div className="flex items-center justify-between">
                <p
                  className="font-inter font-semibold leading-[24px] text-main"
                  style={{ fontSize: "20px" }}
                >
                  {language && language?.["New payment"]
                    ? language?.["New payment"]
                    : "New payment"}
                </p>
                <button
                  type="button"
                  aria-label={
                    language && language?.["Close payment form"]
                      ? language?.["Close payment form"]
                      : "Close payment form"
                  }
                  onClick={() => {
                    setShowPayment(false);
                  }}
                  className="flex items-center justify-center cursor-pointer"
                  style={{ background: "transparent", border: "none", padding: 0 }}
                >
                  <CloseIcon />
                </button>
              </div>
              <div
                className="flex items-center justify-between"
                style={{
                  backgroundColor: "#EBF0F0",
                  padding: "24px",
                  height: "80px",
                  borderRadius: "16px",
                  marginTop: "24px",
                }}
              >
                <p
                  className="font-semibold font-inter leading-[32px]"
                  style={{ color: "#4A5353", fontSize: "24px" }}
                >
                  {language && language?.["Balance"]
                    ? language?.["Balance"]
                    : "Balance"}
                </p>
                <p
                  className="font-semibold font-inter leading-[32px]"
                  style={{ color: "#0F7679", fontSize: "24px" }}
                >
                  {(
                    (Array.isArray(rows) && rows.length > 0
                      ? rows.reduce(
                        (acc: number, val: any) =>
                          acc + (Number(val.amount) || 0),
                        0,
                      )
                      : 0) -
                    (formValuesPayment?.purchasePayment &&
                      Array.isArray(formValuesPayment.purchasePayment)
                      ? formValuesPayment.purchasePayment.reduce(
                        (acc: number, val: any) =>
                          acc + (Number(val.amount) || 0),
                        0,
                      )
                      : 0)
                  ).toFixed(2) || "0.00"}{" "}
                  €
                </p>
              </div>
              {formValues?.creditNote?.id && (
                <div className="" style={{ marginTop: "24px" }}>
                  <p
                    className="font-medium font-inter"
                    style={{ color: "#222525", fontSize: "14px" }}
                  >
                    {language && language?.["Credit notes"]
                      ? language?.["Credit notes"]
                      : "Credit notes"}
                  </p>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      border: "1px solid #EBF0F0",
                      padding: "12px 16px",
                      borderRadius: "12px",
                      marginTop: "8px",
                    }}
                  >
                    <div>
                      <p
                        className="font-semibold font-inter"
                        style={{ color: "#222525", fontSize: "16px" }}
                      >
                        {language && language?.["CN-48392"]
                          ? language?.["CN-48392"]
                          : "CN-48392"}
                      </p>
                      <p
                        className="font-medium font-inter"
                        style={{ color: "#6A7878", fontSize: "14px" }}
                      >
                        {language && language?.["Amount: "]
                          ? language?.["Amount: "]
                          : "Amount: "}
                        <span style={{ color: "#4A5353" }}>
                          {" "}
                          € {formValues?.creditNote?.remainingAmount}
                        </span>
                      </p>
                    </div>
                    {statusCreditNote ? (
                      <div
                        onClick={() => {
                          setStatusCreditNote(false);

                          const totalAmount = Array.isArray(rows)
                            ? rows.reduce((acc: number, val: any) => acc + (Number(val.amount) || 0), 0)
                            : 0;

                          const totalPaid = formValuesPayment?.purchasePayment &&
                            Array.isArray(formValuesPayment.purchasePayment)
                            ? formValuesPayment.purchasePayment.reduce(
                              (acc: number, val: any) => acc + (Number(val.amount) || 0), 0
                            )
                            : 0;

                          const currentValue = Number(formValuesPayment?.value) || 0;
                          const balance = totalAmount - totalPaid - currentValue;
                          const creditAmount = Number(formValues?.creditNote?.remainingAmount);

                          if (creditAmount > balance) {
                            setStatusPayment(true);
                            return;
                          }

                          setStatusPayment(false);
                          setFormValues((prev: any) => ({
                            ...prev,
                            creditNoteAmount: creditAmount,
                          }));

                          setFormValuesPayment((prevState: any) => {
                            const combinedAmount = currentValue + creditAmount;

                            const newPayment = {
                              createdAt: new Date(),
                              reference: prevState?.reference || '',
                              amount: combinedAmount,
                              sale_id: id !== 'new' ? id : '',
                              type: prevState?.type || 'Credit Card',
                              hasCreditValue: true
                            };

                            return {
                              ...prevState,
                              value: '0',
                              reference: '',
                              type: '',
                              purchasePayment: [...(prevState.purchasePayment || []), newPayment],
                            };
                          });
                        }}
                        className="cursor-pointer"
                        style={{
                          padding: "8px 24px",
                          border: "1px solid #0F7679",
                          borderRadius: "30px",
                        }}
                      >
                        <p
                          className="font-medium font-inter"
                          style={{ color: "#0F7679", fontSize: "14px" }}
                        >
                          {language && language?.["Apply"]
                            ? language?.["Apply"]
                            : "Apply"}
                        </p>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setStatusCreditNote(true);
                          setStatusPayment(false);

                          const creditAmount = Number(formValues?.creditNote?.remainingAmount);

                          setFormValues((prev: any) => ({
                            ...prev,
                            creditNoteAmount: 0,
                          }));

                          setFormValuesPayment((prev: any) => {
                            const updatedPayments = [...(prev.purchasePayment || [])];

                            const lastCreditIndex = updatedPayments
                              .map((p: any, i: number) => ({ p, i }))
                              .reverse()
                              .find(({ p }) => Number(p.amount) >= creditAmount)?.i;

                            if (lastCreditIndex !== undefined) {
                              const restoredValue = Number(updatedPayments[lastCreditIndex].amount) - creditAmount;

                              if (restoredValue === 0) {
                                // ✅ Giá trị = 0 → xóa element khỏi mảng
                                updatedPayments.splice(lastCreditIndex, 1);
                              } else {
                                // ✅ Giá trị > 0 → giữ nguyên element, chỉ cập nhật lại amount
                                updatedPayments[lastCreditIndex] = {
                                  ...updatedPayments[lastCreditIndex],
                                  amount: restoredValue,
                                };
                              }

                              return {
                                ...prev,
                                value: restoredValue > 0 ? String(restoredValue) : '0',
                                purchasePayment: updatedPayments,
                              };
                            }

                            return prev;
                          });
                        }}
                        className="cursor-pointer"
                        style={{
                          padding: "8px 24px",
                          border: "1px solid #C9D7D8",
                          borderRadius: "30px",
                        }}
                      >
                        <p
                          className="font-medium font-inter"
                          style={{ color: "#222525", fontSize: "14px" }}
                        >
                          {language && language?.["Undo"]
                            ? language?.["Undo"]
                            : "Undo"}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div style={{ marginTop: "24px" }}>
                <p
                  className="text-[14px] leading-[20px] font-inter font-medium"
                  style={{ color: "#222525" }}
                >
                  {language && language?.["Payment details"]
                    ? language?.["Payment details"]
                    : "Payment details"}
                </p>
                <div
                  className=""
                  style={{
                    marginTop: "8px",
                    borderRadius: "16px",
                    border: "1px solid #EBEBED",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="flex items-center justify-between"
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #EBF0F0",
                    }}
                  >
                    <p
                      className="font-medium font-inter leading-[17px]"
                      style={{ color: "#222525", fontSize: "14px" }}
                    >
                      {language && language?.["Select type"]
                        ? language?.["Select type"]
                        : "Select type"}
                    </p>
                    <div style={{ maxWidth: "200px" }}>
                      <DropdownSearch
                        refKey="type"
                        refs={{ type: paymentRef }}
                        openStates={{ type: isTypeDropdownOpen }}
                        open={(key) =>
                          key === "type" && setIsTypeDropdownOpen(true)
                        }
                        close={(key) =>
                          key === "type" && setIsTypeDropdownOpen(false)
                        }
                        data={listPayment}
                        labelExtractor={(item) => item.paymentName}
                        value={paymentType}
                        setValue={setPayemntType}
                        onSelect={handlePaymentTypeSelect}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between "
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #EBF0F0",
                    }}
                  >
                    <p
                      className="font-medium font-inter leading-[17px] "
                      style={{ color: "#222525", fontSize: "14px" }}
                    >
                      {language && language?.["Reference"]
                        ? language?.["Reference"]
                        : "Reference"}
                    </p>
                    <div className="flex items-center gap-x-2" style={{}}>
                      <input
                        className="text-[14px] font-inter placeholder:text-main text-main p-3 outline-none focus:none bg-transparent"
                        style={{
                          height: "100%",
                          textAlign: "left",
                          maxWidth: "200px",
                          border: "1px solid #DBE4E4",
                          borderRadius: "12px",
                        }}
                        value={formValuesPayment?.reference}
                        name="reference"
                        onChange={(e) => handlePaymentChange(e)}
                        onKeyDown={validateNoSpecialChars}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #EBF0F0",
                    }}
                  >
                    <p
                      className="font-medium font-inter leading-[17px]"
                      style={{ color: "#222525", fontSize: "14px" }}
                    >
                      {language && language?.["Value"]
                        ? language?.["Value"]
                        : "Value"}
                    </p>
                    <div className="flex items-center gap-x-1 relative">
                      <input
                        className="text-[14px] font-inter placeholder:text-main text-main p-3 outline-none focus:none bg-transparent"
                        style={{
                          height: "100%",
                          textAlign: "left",
                          maxWidth: "200px",
                          border: "1px solid #DBE4E4",
                          borderRadius: "12px",
                        }}
                        value={formValuesPayment?.value}
                        name="value"
                        onChange={(e) => handlePaymentChange(e)}
                        onKeyDown={validateDecimalNumer}
                      />
                      <div
                        className="absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <p
                          className="font-medium font-inter leading-[17px]"
                          style={{ color: "#6A7878", fontSize: "16px" }}
                        >
                          €
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-center gap-x-1 cursor-pointer"
                    style={{ backgroundColor: "white", padding: "16px 8px" }}
                  >
                    <PlusIconGray />
                    <p
                      className="text-[14px] leading-[22px] font-inter"
                      style={{ color: "#C9D7D8" }}
                    >
                      {language && language?.["Add new payment"]
                        ? language?.["Add new payment"]
                        : "Add new payment"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="p-3 flex items-center gap-x-2 duration-300"
                  style={{
                    marginTop: "24px",
                    backgroundColor: "#FFF5F5",
                    borderRadius: "4px",
                    visibility: statusPayment ? "visible" : "hidden",
                  }}
                >
                  <ErrorIcon />
                  <p
                    style={{ fontSize: "12px" }}
                    className=" font-inter leading-[16px] font-semibold text-subtitle"
                  >
                    {language &&
                      language?.[
                      "The payment amount is greater than the total payment"
                      ]
                      ? language?.[
                      "The payment amount is greater than the total payment"
                      ]
                      : "The payment amount is greater than the total payment"}
                    .
                  </p>
                </div>
                <div
                  className="absolute flex items-center px-6 gap-x-3"
                  style={{ bottom: "24px", right: "0px" }}
                >
                  <div
                    onClick={() => {
                      handleResetPayment();
                    }}
                    className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center"
                    style={{
                      borderRadius: "30px",
                      padding: "10px 24px",
                      border: "1px solid #C9D7D8",
                      color: "#222525",
                    }}
                  >
                    {language && language?.["Cancel"]
                      ? language?.["Cancel"]
                      : "Cancel"}
                  </div>
                  <div
                    onClick={() => {
                      handlePayment();
                    }}
                    className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center"
                    style={{
                      borderRadius: "30px",
                      padding: "10px 24px",
                      backgroundColor: "#0F7679",
                      color: "#FFFFFF",
                    }}
                  >
                    {language && language?.["Save"]
                      ? language?.["Save"]
                      : "Save"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div
        className="w-full flex items-center justify-end shadow_button relative"
        style={{ gap: "12px", paddingTop: "24px", }}
      >
        <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
        <div
          onClick={() => {
            webNavigate("/" + preLanguage + "/purchases");
          }}
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#222525",
            fontSize: "14px",
            fontWeight: "500",
            border: "1px solid #C9D7D8",
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.["Cancel"] ? language?.["Cancel"] : "Cancel"}
        </div>
        {formValues?.status?.statusName !== "Rejected" &&
          formValues?.status?.statusName !== "Cancelled" && (
            <div className="flex items-center gap-x-3" style={{ opacity: submitting ? 0.6 : 1, pointerEvents: submitting ? "none" : "auto" }}>
              {id === "new" ? (
                <>
                  {/* Button Save as Draft */}
                  <div
                    onClick={(e: any) => {
                      submitGuarded(e, "draft");
                    }}
                    style={{
                      padding: "10px 24px",
                      borderRadius: "30px",
                      color: "#222525",
                      fontSize: "14px",
                      fontWeight: "500",
                      border: "1px solid #C9D7D8",
                    }}
                    className="cursor-pointer flex items-center justify-center"
                  >
                    <p className="text-[14px] leading-[20px] text-main font-inter">
                      {language && language?.["Save as draft"]
                        ? language?.["Save as draft"]
                        : "Save as draft"}
                    </p>
                  </div>

                  {/* Button Save */}
                  <div
                    style={{
                      padding: "10px 24px",
                      borderRadius: "30px",
                      color: "#FFFFFF",
                      fontSize: "14px",
                      fontWeight: "500",
                      backgroundColor: "#0F7679",
                    }}
                    onClick={(e: any) => {
                      submitGuarded(e, "save");
                    }}
                    className="cursor-pointer flex items-center justify-center"
                  >
                    <p className="text-[14px] font-medium leading-[22px] font-inter">
                      {language && language?.["Save"]
                        ? language?.["Save"]
                        : "Save"}
                    </p>
                  </div>
                </>
              ) : (
                id.length > 4 && (
                  <>
                    {/* Button Update */}
                    <div
                      onClick={(e: any) => {
                        submitGuarded(e, "save");
                      }}
                      className="cursor-pointer flex items-center justify-center gap-x-2 "
                      style={{
                        padding: "10px 24px",
                        borderRadius: "30px",
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: "500",
                        backgroundColor: "#0F7679",
                      }}
                    >
                      <p className="text-[14px] font-medium leading-[22px] font-inter">
                        {language && language?.["Update"]
                          ? language?.["Update"]
                          : "Update"}
                      </p>
                    </div>

                    {/* Button Reject */}
                    {(formValues?.status?.statusName === "Sent" ||
                      formValues?.status?.statusName === "Overdue") && (
                        <div
                          onClick={() => {
                            setShowOption({
                              check: true,
                              type: "Reject",
                            });
                          }}
                          style={{
                            padding: "10px 24px",
                            borderRadius: "30px",
                            color: "white",
                            backgroundColor: "#BA0E13",
                          }}
                          className="cursor-pointer flex items-center justify-center"
                        >
                          <p className="text-[14px] leading-[20px] font-inter font-medium">
                            {language && language?.["Reject"]
                              ? language?.["Reject"]
                              : "Reject"}
                          </p>
                        </div>
                      )}

                    {/* Button Cancel */}
                    {formValues?.status?.statusName !== "Paid" && (
                      <div
                        onClick={() => {
                          setShowOption({
                            check: true,
                            type: "Cancel",
                          });
                        }}
                        className="cursor-pointer flex items-center justify-center"
                        style={{
                          padding: "10px 24px",
                          borderRadius: "30px",
                          border: "1px solid #BA0E13",
                          color: "#BA0E13",
                        }}
                      >
                        <p className="text-[14px] leading-[20px] font-inter font-medium">
                          {language && language?.["Cancel purchase"]
                            ? language?.["Cancel purchase"]
                            : "Cancel purchase"}
                        </p>
                      </div>
                    )}
                  </>
                )
              )}
            </div>
          )}
      </div>
      <PopupLocation
        show={showPopup}
        title={`${id === "new" ? (language && language?.["Create Purchases"] ? language?.["Create Purchases"] : "Create Purchases") : language && language?.["Update Purchases"] ? language?.["Update Purchases"] : "Update Purchases"}`}
        desc={`${locationId === "" ? (language && language?.["Please select location in the upper left corner to continue creating"] ? language?.["Please select location in the upper left corner to continue creating"] : "Please select location in the upper left corner to continue creating") : id === "new" ? (language && language?.["File to large"] ? language?.["File to large"] : "File to large") : language && language?.["File to large"] ? language?.["File to large"] : "File to large"}`}
        onClose={handleClosePopup}
        onOpen={handleOpenPopup}
      />
      <div
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showPopupImage ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "rgba(0,0,0,0.8)",
          zIndex: "200",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          width: "100%",
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showPopupImage ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            borderRadius: "6px",
            backgroundColor: "white",
            width: "80%",
            height: "90%",
            transition: "transform 0.3s ease, opacity 0.3s ease",
            overflow: "hidden",
          }}
        >
          <div className="flex items-center justify-between">
            <p className="text-[16px] font-semibold font-inter text-main leading-[24px]"></p>
            <div
              onClick={() => {
                setShowPopupImage(false);
              }}
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "100%",
                backgroundColor: "#D1E4E5",
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <div
            className="flex items-center justify-center"
            style={{ padding: "20px 16px", height: "calc(100% - 48px)" }}
          >
            {(base64PDF || base64Image || formValues?.file) && (
              <iframe
                src={
                  base64PDF
                    ? base64PDF
                    : base64Image
                      ? base64Image
                      : formValues?.file
                }
                width="100%"
                height="100%"
              >
                {" "}
              </iframe>
            )}
          </div>
        </div>
      </div>
      <div
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showOption?.check
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
          } transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "200",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          width: "100%",
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showOption?.check ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "#FFFFFF",
            width: "530px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between">
            <p
              style={{ fontSize: "20px" }}
              className="font-semibold font-inter text-main leading-[24px]"
            >
              {showOption?.type === "Cancel"
                ? "Cancel Purchase"
                : "Reject Purchase"}
            </p>
            <div
              onClick={() =>
                setShowOption({
                  check: false,
                  type: "",
                })
              }
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <div
            className="flex items-center justify-between"
            style={{ marginTop: "12px" }}
          >
            <p
              className="text-[14px] font-inter leading-[24px]"
              style={{ color: "#6A7878" }}
            >
              {(() => {
                const actionType =
                  showOption?.type === "Cancel" ? "cancel" : "reject";
                const message = `You will permanently ${actionType} the purchase`;
                return language && language?.[message]
                  ? language?.[message]
                  : message;
              })()}
            </p>
          </div>
          <div
            className="flex items-center justify-end"
            style={{ marginTop: "24px", gap: "12px" }}
          >
            <div
              onClick={() =>
                setShowOption({
                  check: false,
                  type: "",
                })
              }
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                border: "1px solid #C9D7D8",
                color: "#222525",
              }}
            >
              {language && language?.["Cancel"]
                ? language?.["Cancel"]
                : "Cancel"}
            </div>
            <div
              onClick={handleDeleteSale}
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                backgroundColor: "#BA0E13",
                color: "#FFFFFF",
              }}
            >
              {showOption?.type === "Cancel"
                ? "Cancel Purchase"
                : "Reject Purchase"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CreatePurchases;
